import {
  Component, OnInit, Input, Output, OnChanges, EventEmitter, HostListener ,
  Directive, ViewContainerRef, ViewChildren, QueryList, ComponentFactoryResolver, AfterContentInit, ComponentRef, ViewChild, TemplateRef, ElementRef
} from '@angular/core';

import { FormdashboardService } from './formdashboard.service';
import { Router, ActivatedRoute, NavigationExtras } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ToastrService } from 'ngx-toastr';
import { formconfig } from '../../configuration/formconfig/formconfig';
import { JSONTableModule } from 'angular-json-table';
import { DatabaseService } from '../../Master/database/database.service';
import { FormconfigService } from '../../configuration/formconfig/formconfig.service';
import { FormrenderService } from '../../formrender/formrender.service';
import { UserService } from '../../Master/user/user.service';
import { ContextMenuComponent, ContextMenuService } from 'ngx-contextmenu';
import { BsModalService, BsModalRef, ModalOptions } from 'ngx-bootstrap';
import { TeamMgtService } from '../../teammgt/teammgt.service';
import { FormrenderComponent } from '../../formrender/formrender.component';
import { DialogService } from 'ng2-bootstrap-modal';
import { CommondialogComponent } from '../../Shared/commondialog/commondialog.component';
import { isNil, remove, reverse } from 'lodash';
import { TreeviewModule, TreeviewConfig, TreeviewI18n, TreeviewItem, DownlineTreeviewItem, TreeviewEventParser, OrderDownlineTreeviewEventParser } from 'ngx-treeview';
import { map } from 'rxjs/operators';
import { NgxDatatableModule, DatatableComponent, TableColumn } from '@swimlane/ngx-datatable';
import { AngularDualListBoxModule } from 'angular-dual-listbox';
import { DatePipe } from '@angular/common';
import { FormDashboard } from './formdashboard';
import { Angular5Csv } from 'angular5-csv/dist/Angular5-csv';
import * as XLSX from 'xlsx';
import { NgbTabset } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from "ngx-spinner";
import * as _ from 'lodash';
import { NewsletterComponent } from '../../Shared/newsletter/newsletter.component';
import { NewsletterService } from '../../Shared/newsletter/newsletter.service';
import { environment } from '../../../environments/environment';
import { FormdashboardgrouptableComponent } from '../../Shared/formdashboardgrouptable/formdashboardgrouptable.component';
import { Observable } from 'rxjs';
import { RequestconfigService } from '../../configuration/requestconfig/requestconfig.service';
import { saveFile, saveAs } from 'file-saver';
import { LocalService } from '../../local.service';
import {encryptdecrypt} from '../../encryptdecrypt';
declare var $: any;



@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[groupcontainer]',
})
export class groupDatacontainerDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}

@Component({
  selector: 'app-formdashboard',
  templateUrl: './formdashboard.component.html',
  styleUrls: ['./formdashboard.component.css'],
  providers: [NgbTabset, ToastrService, { provide: TreeviewEventParser, useClass: OrderDownlineTreeviewEventParser }]

})

export class FormdashboardComponent implements OnInit {
  // @ViewChild(ContextMenuComponent, { static: false }) public basicMenu: ContextMenuComponent;
  @ViewChild('myTable', { static: false }) Table: DatatableComponent;
  @ViewChild('tabs', { static: false })
  private tabs: NgbTabset;

  list: any;
  formlist: any = [];
  headers: any;
  headersgroup: any;
  _master: any = []; _masterList: any; _masterValues: any; UserList: any; itemsPerPage: number = 10;
  p: number = 1; selectedFormConfigId: number; searchText: string; u: number[] = [];
  formConfigName: string; requestTypeList: any = []; userid: number = 0; userRole: string = '';
  pageevent: boolean = false;
  sortingcondition: string = '';
  sortDirection: string = 'desc'; colkey: string = '';
  readOnly: boolean;
  add: boolean;
  edit: boolean;
  delete: boolean;
  submitShow: boolean;
  _actionRights: any;
  formConfigId: number = 0;
  listTmp: any;
  config: ModalOptions = {
    backdrop: 'static',
    keyboard: false,
    animated: true,
    class: 'modal-dialog-centered',
    ignoreBackdropClick: true
  }
  
  togglegroupby: boolean = true;
  isExpanded: boolean = false; public databaseId: number; databaseName: string; databaseIcon: any; dataBases: any = [];
  previewFlag: boolean = false; selectedNodeValue: string = '';

	show = false;
  paginationLimit:Number; 
  showShortDesciption = true
  startPage : Number;		   
	paginationLimit1:Number; 
  showShortDesciption1 = true
  startPage1 : Number;					   
  //tree view

  treeviewlist: any = [];

  configTreeview = TreeviewConfig.create({
    hasAllCheckBox: false,
    hasFilter: false,
    hasCollapseExpand: false,
    decoupleChildFromParent: false,
    // maxHeight: 400
  });
  itemsList: TreeviewItem[]; itemsListtmp: TreeviewItem[]; rows: string[];
  searchedFormList: any = []; formSearchDetailsList: any = []; by: string = ''; searchData: string = '';

  //datatable
  @ViewChild('myTable', { static: false }) table: any;
  // private readonly table1: DatatableComponent;
  rowsData: any = []; columns: any = [];
  groupSearch: boolean = false;
  groupExpansionDefault: boolean = false;
  groupRowsBy: string = ''; selectedNodeText: string = ''; loadingIndicator: boolean = true; itemsPerPageText: number = 10;

  //Advanced search
  _dropdownSettings: any; _dropdownSettingsform: any;
  authorListTmp: any = [];
  authorList: any = [];
  formConfigList: any = []; authorDiv: boolean = true; FormDiv: boolean = true; FormFieldsDiv: boolean = true;
  formFieldsListTmp: any = []; formFieldsList: any = []; selectedFormId: string = ''; selectedStartDate: any; selectedFormFields: any = []; _selectedItems: any = [];
  filternameTxt: string = ''; allAdvancedSearchList: any[]; customSearchDocumentList: any = []; customSearchHeaders: any; customcolumns: any = [];
  allCustomSearchList: any = []; userSelectedFilter: string = ''; initialRowDataList: any = []; previewFilterList: any = []; previewSearchHeaders: any = []; previewcolumns: any = [];
  //selectedfieldDate: any;
  selectedfieldDate = [];
  fieldgroupList: any = []; fieldgroupListadded: any = []; showStatus: number = 0; fromrender: number = 0; groupByList: any = []; _colspan: number = 0; collapsetext: string = 'Collapse All';
  formconfigidnewsletter: number = 0;
  totalformdetailcount: number = 0;
  federalDatabaseId: number = 0;
  _itemsPerPage: number = 100;
  totalsearchcount: number = 0;
  advancedSearchId: number = 0;
  showAllChecked: boolean = false;
  advancedSearchEditMode: boolean = false;
  //group by

  itemsperpagegroup: number = 5;
  groupname: string = '';
  formSearchDetailsListfield: any = [];
  columnsearchcondition: string = ''; addFormFields: boolean = true; selectedSearchDate: any = []; columnsearch: boolean = false; _columnsearchgroup: any = []; formConfigField: any[]; _columnsearchgroupformrender: any = [];
  //modal pop up
  modalRef: BsModalRef;
  customSearchEnable = false;
  columnshow: boolean = false;
  previewfilterflag: boolean = false;
  selectedgroup: any;
  groupByFromRender: boolean = false;
  filterPatchData = [];
  filterValue = [];
  isCustomSearch = false;
  customSearchData = '';
  customSearchValue = '';
  subPage = 1;
  searchDataValue = '';
  state: any;
  groupleveldata = '';
  groupleveldataname = '';

  //sort for back from form render

  isSort = false;
  sortingconditionValue = '';
  isSortGroupBy = false;
  sortingconditionGroupBy = '';
  sortingDirectionGroupBy = '';
  customSearchSortConditionValue = '';
  sortingconditionValueGroupBy = '';
   requestDetails = [];
  //scroll position
  public spt = '0'; public spl: any;


  //item per page lock
  isitemperpagechanged = false;
  
  //groupby click component calling

  innerRowsData = [];
  groupname2 = '';

  selectedgroupdata: any = [];
  searchTextforDatabase: '';
  //archive dashboard

  archiveyear = 0;  archiveformconfigid = 0;
  archivedashboard = '';
  backcourtsearchData = '';

	searchbyallocation:any;					 
  //mark as read
  markallcheckbox = false;

  //formrender next unread
  countConditionObj: any;
  getvaluesConditionObj: any;
  isadvancesearch = false;

  //contextmenu

  item: any;

  itemperpagechild: number = 10;

//search in treemenu
  searchTextforTreeview: string;


	@ViewChild('viewMenu', {static: true}) public viewMenu: ContextMenuComponent;
@ViewChild('basicMenu1', {static: true}) public basicMenu1: ContextMenuComponent;																		   


  @ViewChildren(groupDatacontainerDirective) entry: QueryList<groupDatacontainerDirective>;
  enc=new encryptdecrypt();
  constructor(private _router: Router, private formdashboardservice: FormdashboardService, public sanitizer: DomSanitizer, private toastr: ToastrService, private userservice: UserService,
    private route: ActivatedRoute, private databaseService: DatabaseService, private formRenderService: FormrenderService,
    private formConfigService: FormconfigService, private contextMenuService: ContextMenuService,
    public bsModalRef: BsModalRef, private modalService: BsModalService,
    private teamMgtSer: TeamMgtService, private dialogService: DialogService, private datePipe: DatePipe, public tabset: NgbTabset, private resolver: ComponentFactoryResolver,
    private SpinnerService: NgxSpinnerService, private mailConfigSer: NewsletterService, 
    private requestConfigService: RequestconfigService,
    private localService: LocalService) {
   
    this.route.queryParamMap.subscribe(qParams => {
      let params = qParams['params'];
      //let a= new encryptdecrypt();
      var dbid= this.enc.decryptUsingAES256(params['db'].toString());
      this.databaseId = +dbid;//+params['db'];  
       if (params['formconfigid'] != undefined) {
        var formconfigid= this.enc.decryptUsingAES256(params['formconfigid'].toString());
        this.formConfigId = +formconfigid;//+params['formconfigid'];
      }
      if (params['archiveformconfigid'] != undefined) {
        this.archiveformconfigid = this.enc.decryptUsingAES256(params['archiveformconfigid'].toString());//+params['archiveformconfigid'];
      }
      if (params['archiveyear'] != undefined) {
        this.archiveyear = this.enc.decryptUsingAES256(params['archiveyear'].toString());//+params['archiveyear'];
      }
    });
	 this.startPage = 0;
    this.paginationLimit = 5;				   
    const navigation = this._router.getCurrentNavigation();
    this.state = navigation.extras.state as {
      db: any,
      formDB: any,
      data: any,
      formConfigId: any,
      mode: any,
      page: any,
      selectedgroup: any,
      searchdata: any,
      filterTable: any,
      filterValue: any,
      isCustomSearch: any,
      itemsPerPage: any,
      subPage: any;
      customSearchData: any,
      selectedNodeText: any,
      columnsearchname: any,
      columnsearchgroup: any,
      formrender: any,
      isSort: any,
      sortingconditionValue: any,
      isSortGroupBy: any,
      sortingconditionGroupBy: any,
      sortDirectionValue: any,
      sortingDirectionGroupBy: any,
      customSearchSortConditionValue: any,
      sortingconditionValueGroupBy: any,
      selectedNodeValue: any,
      groupleveldata:any

    };

    this.by = 'All';
    if (this.state != null && this.state != undefined) {
      this.databaseId = +this.state.db;

      this.formConfigId = + this.state.formConfigId;
      this.fromrender = +this.state.formrender;
      if (this.state.page != undefined && this.state.page != 'NaN')
        this.p = +this.state.page;
      else
        this.p = 1;

      if (this.state.selectedgroup != undefined && this.state.selectedgroup != "" && this.state.selectedgroup != "All"
        && this.state.selectedgroup != 'teamallocation' && this.state.selectedgroup != 'teamallocationreview' && this.state.selectedgroup != 'teamallocationnotreview') {
        this.groupRowsBy = this.state.selectedgroup;
        this.groupByFromRender = true;
        this.groupSearch = true;
        this.groupExpansionDefault = true;
        if (this.state.columnsearchgroup != null && this.state.columnsearchgroup != undefined && this.state.columnsearchgroup != '') {
          this.headersgroup = JSON.parse(this.state.columnsearchname || '[]');
          this._columnsearchgroupformrender = JSON.parse(this.state.columnsearchgroup || '[]');
        }
      }

      if (this.state.selectedgroup == 'teamallocation' || this.state.selectedgroup == 'teamallocationreview' || this.state.selectedgroup == 'teamallocationnotreview') {
        this.by = this.state.selectedgroup;
      }

      if (this.state.searchdata != undefined && this.state.searchdata != "") {
        this.searchData = this.state.searchdata;
        this.groupname = this.state.selectedgroup;
      }

      if (this.state.columnsearchgroup != null && this.state.columnsearchgroup != undefined && this.state.columnsearchgroup != '' && this.state.columnsearchgroup != '[]') {
        if (this.state.selectedgroup == 'teamallocation' || this.state.selectedgroup == 'teamallocationreview' || this.state.selectedgroup == 'teamallocationnotreview') {
          this.by = this.state.selectedgroup;
        }
        this.headers = JSON.parse(this.state.columnsearchname || '[]');
        this._columnsearchgroup = JSON.parse(this.state.columnsearchgroup || '[]');
        this.headersgroup = JSON.parse(this.state.columnsearchname || '[]');
        this._columnsearchgroupformrender = JSON.parse(this.state.columnsearchgroup || '[]');
      }
      if (this.state.archiveyear != null && this.state.archiveyear != undefined && this.state.archiveyear != '') {
        this.archiveyear=this.state.archiveyear;
      }

      if (this.state.filterTable == "true") {
        this.filterValue = this.state.filterValue != undefined && this.state.filterValue != null ? JSON.parse(this.state.filterValue) : [];
      }
      this.isCustomSearch = this.state.isCustomSearch == undefined ? false : JSON.parse(this.state.isCustomSearch);
      this.customSearchValue = this.state.customSearchData;
      this._itemsPerPage = this.state.itemsPerPage == undefined ? 10 : this.state.itemsPerPage;
      this.subPage = this.state.subPage;
      this.selectedNodeText = this.state.selectedNodeText;
      this.selectedNodeValue = this.state.selectedNodeValue;
      //sorting

      this.isSort = this.state.isSort;
      this.sortingconditionValue = this.state.sortingconditionValue;
      this.isSortGroupBy = this.state.isSortGroupBy;
      this.sortingconditionGroupBy = this.state.sortingconditionGroupBy;
      this.sortDirection = this.state.sortDirectionValue;
      this.sortingDirectionGroupBy = this.state.sortingDirectionGroupBy;
      this.customSearchSortConditionValue = this.state.customSearchSortConditionValue;
      this.sortingconditionValueGroupBy = this.state.sortingconditionValueGroupBy;



    
    }
  }

  public getRowIndex(row: any): number {
    return this.rowsData.map((item) => item.id).indexOf(row.id);   // row being data object passed into the template
  }

 
  @HostListener('window:scroll', ['$event'])
  onScroll(event: any) {
    sessionStorage.setItem('scrolltop', event.srcElement.scrollingElement.scrollTop);
    sessionStorage.setItem('scrollleft', event.srcElement.scrollingElement.scrollLeft);
  }
  ngAfterViewChecked() {

    let newRowsCount = this.rowsData.length;
    if (newRowsCount <= 0)
      return;
    else {
      if (sessionStorage.getItem('scrolltop') && this.spt!='0') {
        window.scrollTo({
          top: +this.spt
        });

        this.spt = '0';
      }
    }
    
   
  }

  onHide($event){    
	//	alert('hi');
    console.log("Dashboard button is clicked!", $event);    
    $('.show_filter').toggleClass('hide_filter');
		$('.hide_filter.hide').toggleClass('block');
		$('.left_tree_container').toggleClass('minify_left_tree');
		$('.grid_container').toggleClass('maximum_grid_container');
  }    


  ngOnInit() {

    this._master = []; this._masterValues = []; this.UserList = ''; this.selectedFormConfigId = 0; this.formlist = [];
    this.databaseName = ''; this.formConfigName = '';
    this.columns = []; this.rowsData = [];
    //this.userid = +localStorage.getItem('userid');
    this.userid = +this.localService.getJsonValue('userid');
    // console.log('userid' + this.userid);
    //this.userRole = localStorage.getItem('userrole');
    this.userRole = this.localService.getJsonValue('userrole');
    // console.log(this.formConfigId);
    //this.LoadMasterList();
    // this.LoadAllMasterDetails();
    this.getpagepreference();
    this.LoadAllUserList();
    this.LoadDatabase(); this.LoadRequestTypeList();
    this.Loadtree();

    if (sessionStorage.getItem('scrolltop'))
    {
      this.spt = sessionStorage.getItem('scrolltop');

    }
    if (this.archiveyear != 0 && this.archiveyear != undefined) {
      this.archivedashboard = 'Archive ';
    }
    else
      this.archivedashboard = '';
    if (this.state != null && this.state != undefined) {

      if (this.state.columnsearchgroup != null && this.state.columnsearchgroup != undefined && this.state.columnsearchgroup != '' && this._columnsearchgroup.length > 0 && this.groupSearch != true) {
        this.formdashboardservice.getFormConfig().subscribe(
          (res) => {
            this.formConfigList = res;
            this.list = res;
            if (this.isSort == true) {
              this.sortingcondition = this.customSearchSortConditionValue;
            }
            if (this.isCustomSearch == true) {

              if (this.customSearchValue != undefined && this.customSearchValue != '' && this.customSearchValue != null) {
                let str: string;
                str = JSON.parse(this.customSearchValue).value;
                var s = str.toString().split('*');
                this.isCustomSearch = true;
                this.customSearchData = JSON.stringify(JSON.parse(this.customSearchValue));
                // this.columnsearch = true;
                this.customSearchEnable = true;
                this.advancedSearchId = +s[1];

              }
            }
            this.loadcolumnsearchdata(this._columnsearchgroup, this.p);

            this.columnshow = true;
          });
      }
      else {

        if (this.isSort && !this.isCustomSearch) {
          this.formdashboardservice.getFormConfig().subscribe(
            (res) => {
              this.formConfigList = res;
              this.list = res;
              this.selectedFormConfigId = this.formConfigId;
              this.formConfigName = this.selectedNodeText;
              this.colkey = this.sortingconditionValue;
              this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
              this.sorting(this.sortingconditionValue, '0');
            });
        }
        else if (this.isCustomSearch) {
          this.formdashboardservice.getFormConfig().subscribe(
            (res) => {
              this.formConfigList = res;
              this.list = res;
              this.selectedFormConfigId = this.formConfigId;
              // this.onSelectedChange(JSON.parse(this.customSearchValue));
              if (this.customSearchValue != undefined && this.customSearchValue != '' && this.customSearchValue != null) {

                this.isCustomSearch = true;
                let str: string;
                str = JSON.parse(this.customSearchValue).value;

                var s = str.toString().split('*');
                this.isCustomSearch = true;
                this.customSearchData = JSON.stringify(JSON.parse(this.customSearchValue));
                // this.columnsearch = true;
                this.customSearchEnable = true;
                this.advancedSearchId = +s[1];
              }
              let sort = this.customSearchSortConditionValue == undefined || this.customSearchSortConditionValue == '' ? null : this.customSearchSortConditionValue;
              this.showAdvancedSearch(this.advancedSearchId, this.p, sort);


              // this.sorting(this.sortingconditionValue, '0');

            });
        }
        else if (this.state.selectedgroup == 'teamallocation' || this.state.selectedgroup == 'teamallocationreview' || this.state.selectedgroup == 'teamallocationnotreview') {
          this.formdashboardservice.getFormConfig().subscribe(
            (res) => {
              this.formConfigList = res;
              this.list = res;
              this.selectedFormConfigId = this.formConfigId;
              this.formConfigName = this.selectedNodeText;
              // this.selectedNodeValue = this.state.selectedgroup;

              this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.formConfigId);
              //  this.loadformdetails(this.listTmp[0]);
              this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, this.p, 0);
              this.selectedNodeText = this.listTmp[0].formconfigname;
              // this.selectedNodeValue = this.listTmp[0].formconfigid;
              this.showFormFields(this.listTmp[0], this.formConfigId);
              this.selectedNodeText = this.state.selectedNodeText;
              this.selectedNodeValue = this.state.selectedNodeValue;
            });

        }
        else {
          this.Loadformdetails(this.p);
          
        }
      }

    }
    else {
      if (this.isSort && !this.isCustomSearch) {
        this.formdashboardservice.getFormConfig().subscribe(
          (res) => {
            this.formConfigList = res;
            this.list = res;
            this.selectedFormConfigId = this.formConfigId;
            this.formConfigName = this.selectedNodeText;
            this.colkey = this.sortingconditionValue;
            this.sortDirection = this.sortDirection == 'asc' ? 'desc' : 'asc';
            this.sorting(this.sortingconditionValue, '0');
          });
      }
      else if (this.isCustomSearch) {
        this.formdashboardservice.getFormConfig().subscribe(
          (res) => {
            this.formConfigList = res;
            this.list = res;
            this.selectedFormConfigId = this.formConfigId;
            //   this.onSelectedChange(JSON.parse(this.customSearchValue));
            // this.sorting(this.sortingconditionValue, '0');


            if (this.customSearchValue != undefined && this.customSearchValue != '' && this.customSearchValue != null) {

              this.isCustomSearch = true;
              let str: string;
              str = JSON.parse(this.customSearchValue).value;

              var s = str.toString().split('*');
              this.isCustomSearch = true;
              this.customSearchData = JSON.stringify(JSON.parse(this.customSearchValue));
              // this.columnsearch = true;
              this.customSearchEnable = true;
              this.advancedSearchId = +s[1];
            }
            let sort = this.customSearchSortConditionValue == undefined || this.customSearchSortConditionValue == '' ? null : this.customSearchSortConditionValue;
            this.showAdvancedSearch(this.advancedSearchId, this.p, sort);


          });
      }
      else {
        this.Loadformdetails(this.p);
        
      }
    }

    // this.formSearchDetails();
    this.itemsPerPageText = 10;
    this.getActionRightsList();
    this.getFederalDatabaseId();

    //  this.loadFilter();

    $('body').addClass('nav-sm').removeClass('nav-md');
    $('#sidebar-menu .side-menu li.active, #sidebar-menu .side-menu li.active-sm').removeClass('active active-sm').find('ul').slideUp();
    this.changeitemsperpage(this._itemsPerPage);
  }


  assignLabelValues() {
    if (this.isCustomSearch == false) {
      if (this.groupRowsBy.trim() == '') {
        this.selectedNodeText = this.selectedNodeText;
        this.selectedNodeValue = this.formConfigId.toString();
      }
      else {
        this.selectedNodeText = this.selectedNodeText;
        this.selectedNodeValue = this.groupRowsBy + '*' + this.formConfigId.toString();
      }
    }
    else {
      let _str: string;
      _str = JSON.parse(this.customSearchValue).value;
      var _s = _str.toString().split('*');
      this.selectedNodeValue = _s[1];
      this.selectedNodeText = JSON.parse(this.customSearchValue).text;
    }
  }



  async getFormDisplayField(id) {
    return await this.formConfigService.getFormConfigDisplayField(id).toPromise().then(res => res);
  }

  getFederalDatabaseId() {
    this.formConfigService.getFederalDatabaseId().subscribe((res) => {
      if (res != undefined && res != null) {
        this.federalDatabaseId = res;
      }
    })
  }

  Loadformdetails(pagenumber) {
    this.SpinnerService.show();
    this.formdashboardservice.getFormConfig().subscribe(
      (res) => {
        if (this.groupByFromRender == false) {
          if (pagenumber == 1 && this.selectedFormConfigId == 0) {
            if (res != undefined) {
              this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1);
              //form config multi select
              this.formConfigList = res;
              this.list = res;
              if (this.formConfigId == 0) {
                if (this.archiveyear == 0) {
                  this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
                  this.selectedNodeText = this.listTmp[0].formconfigname;
                  this.selectedNodeValue = this.listTmp[0].formconfigid;
                  this.showFormFields(this.listTmp[0], this.listTmp[0].formconfigid);
                }
                else {
                  this.listTmp = this.listTmp.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.treeviewlist[0].formconfigid);

                  this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
                  this.selectedNodeText = this.listTmp[0].formconfigname;
                  this.selectedNodeValue = this.listTmp[0].formconfigid;
                  this.showFormFields(this.listTmp[0], this.listTmp[0].formconfigid);
                }
              }
              else {
                this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.formConfigId);
                //  this.loadformdetails(this.listTmp[0]);
                this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
                this.selectedNodeText = this.listTmp[0].formconfigname;
                this.selectedNodeValue = this.listTmp[0].formconfigid;
                this.showFormFields(this.listTmp[0], this.formConfigId);
              }
            }
          }
          else {
            if (this.selectedFormConfigId == 0)
              this.selectedFormConfigId = this.formConfigId;
            this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId);
            this.formConfigList = res;
            this.list = res;
            this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
            if (this.by == 'All') {
              this.selectedNodeText = this.listTmp[0].formconfigname;
              this.selectedNodeValue = this.listTmp[0].formconfigid;
            }

            this.showFormFields(this.listTmp[0], this.formConfigId);
          }
        }

        else {
          if (res != undefined) {

            this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.formConfigId);
            this.formConfigList = res;
            this.list = res;
            this.by = this.groupRowsBy;
            var i = 1;
            // if (this.isCustomSearch) {
            // this.onSelectedChange(JSON.parse(this.customSearchValue));
            //this.isCustomSearch = false;
            // } else {
            if (this.groupRowsBy == 'All') {
              this.selectedNodeText = this.listTmp[0].formconfigname;
              this.selectedNodeValue = this.listTmp[0].formconfigid;
            }

            else {
              this.selectedNodeText = this.selectedNodeText;
              this.selectedNodeValue = this.groupRowsBy + '*' + this.formConfigId.toString();
            }
            this.LoadSearchedFormDetails(this.listTmp[0], this.groupRowsBy, '', this.p, 0);
            //  }
            //if (this.entry.length > 0) {
            //  this.entry.forEach(container => {
            //    container.viewContainerRef.clear();
            //  });
            //}

            //this.loaddetails(this.list[0], this.groupRowsBy, this.searchData, this.p, this.groupRowsBy,  this.groupRowsBy);

          }
        }
      },
      error => {
        this.SpinnerService.hide();
        this.toastr.error(error.error);
      });
  }

  // Loadformdetails(pagenumber) {
  //   this.SpinnerService.show();
  //   this.formdashboardservice.getFormConfig().subscribe(
  //     (res) => {
  //       if (pagenumber == 1 && this.selectedFormConfigId == 0) {
  //           this.list = res.filter(e => e.dbid == this.databaseId && e.active == 1);
  //           //form config multi select
  //           this.formConfigList = this.list;
  //           if (this.formConfigId == 0) {
  //             this.LoadSearchedFormDetails(this.list[0], this.by, this.searchData, pagenumber, 0);
  //             this.selectedNodeText = this.list[0].formconfigname;
  //             this.selectedNodeValue = this.list[0].formconfigid;
  //             this.showFormFields(this.list[0], this.list[0].formconfigid);
  //           }
  //           else {
  //             this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.formConfigId);
  //             //  this.loadformdetails(this.listTmp[0]);
  //             this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
  //             this.selectedNodeText = this.listTmp[0].formconfigname;
  //             this.selectedNodeValue = this.listTmp[0].formconfigid;
  //             this.showFormFields(this.listTmp[0], this.formConfigId);
  //           }
  //         }
  //       }
  //       else {
  //         if (this.selectedFormConfigId == 0)
  //           this.selectedFormConfigId = this.formConfigId;
  //         this.listTmp = res.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId);
  //         this.formConfigList = res;//this.listTmp;
  //         //  this.loadformdetails(this.listTmp[0]);
  //         this.LoadSearchedFormDetails(this.listTmp[0], this.by, this.searchData, pagenumber, 0);
  //         this.selectedNodeText = this.listTmp[0].formconfigname;
  //         this.selectedNodeValue = this.listTmp[0].formconfigid;
  //         this.showFormFields(this.listTmp[0], this.formConfigId);
  //       }
  //     },
  //     error => {
  //       this.SpinnerService.hide();
  //       this.toastr.error(error.error);
  //     });
  // }
  LoadAllUserList() {
       let a= new encryptdecrypt();
    this.userservice.Get().subscribe(res => {
      // console.log(res);
       res.forEach((data: any) => {
        data.firstname = a.decryptUsingAES256(data.firstname);
        data.lastname = a.decryptUsingAES256(data.lastname);
        data.emailid = a.decryptUsingAES256(data.emailid);
      });
      this.UserList = res;
      //load the author dropdown
      var allData = res.filter(e => e.active == 1);
      // console.log(allData);
      allData.forEach(data => {
        if (data.active != 0) {
          this.authorListTmp.push({ authorId: data.userid, authorName: data.firstname });
        }
      });
      this._dropdownSettings = {
        singleSelection: false,
        idField: 'authorId',
        textField: 'authorName',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this.authorList = JSON.parse(JSON.stringify(this.authorListTmp));
    }, error => { this.toastr.error('Error while getting users data') });

  }

  LoadMasterList() {
    this.formRenderService.getmaster().toPromise().then(master => {
      this._master = master;
    });
  }

  LoadAllMasterDetails() {
    this.formdashboardservice.getAllMasterDetails().subscribe(res => {
      this._masterList = res;
    });
  }

  LoadRequestTypeList() {
    this.teamMgtSer.GetRequestType().subscribe(res => {
      var allData = res;
      // console.log(res);
      allData.forEach(data => {
        if (data.active != 0) {
          this.requestTypeList.push({ requesttypeid: data.requesttypeid, requesttype: data.requesttype })
        }
      });
    }, error => { this.toastr.error('Error while getting data'); });
  }

  showRequestConfig(message: any, requestTypeId) {
    // this._router.navigate(['/home/requestconfig'],
    // { queryParams: { 'db': this.databaseId, 'documentId': message.item["documentid"], 'formConfigId': this.selectedFormConfigId, 'requesttypeid': requestTypeId, 'formName': this.formConfigName } });
    let queryParams = {
      'db': this.enc.encryptUsingAES256(this.databaseId.toString()),
      'documentId': this.enc.encryptUsingAES256(message.item["documentid"].toString()),
      'formConfigId': this.enc.encryptUsingAES256(this.selectedFormConfigId.toString()),
      'requesttypeid': this.enc.encryptUsingAES256(requestTypeId.toString()),
      'formName': this.enc.encryptUsingAES256(this.formConfigName.toString())
    };
    let url = this._router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');
  }

  getActionRightsList() {
    this.userservice.Get().subscribe(res => {
      let allUser: any = [];
      allUser = res.find(y => y.userid == this.userid);
      var data = JSON.parse(allUser.menumapped);
      if (data != null && data != undefined && data.length != 0) {
        data = data.filter(e => e.menuid == 38);
        if (data != null && data != undefined && data.length != 0)
          this._actionRights = data[0].action;
        else
          this._actionRights = [];

      }
      var btnToEnable = this._actionRights;
      if (btnToEnable.length > 0) {
        btnToEnable.forEach(d => {
          if (d != undefined) {
            if (d == 1)
              this.readOnly = true;
            else if (d == 2) {
              this.readOnly = true;
              this.add = true;
              this.submitShow = true;
            }
            else if (d == 3) {
              this.readOnly = true;
              this.edit = true;
              // this.submitShow = true;
            }
            else if (d == 4) {
              this.readOnly = true;
              this.delete = true;
            }
          }
        });
      }
      //  console.log(this.delete);
    });

  }

  removeFormDocument(item) {
    // console.log(item);


    var documentid = 0;
    if ((this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
      documentid = item["documentid"];
    }
    else {
      documentid = item["ACRN Doc ID"];
    }

    var _inputData = [];
    _inputData.push(
      {
        'formconfigid': this.selectedFormConfigId,
        'tablename': this.formConfigName.replace(' ', '').toLowerCase(),
        'documentid': documentid,
        'createdby': this.userid
      })

    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to remove this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formRenderService.Delete(_inputData[0]).subscribe(
            (res) => {
              if (res.body != 0) {
                this.toastr.success("Record deactivated successfully");
                var s = this.list.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId);
                // this.loadformdetails(s[0]);
                this.LoadSearchedFormDetails(s[0], this.by, this.searchData, this.p, 0);
                // this.LoadMailTemplateList();
              }
            }, error => {
              // console.log(error);
              this.toastr.error(error);
            });
        }
      });
  }

  removeSpecialCharacters(text) {
    var cleanedTxt = text.replace(/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g, '');
    return cleanedTxt;
  }

  validateFields(item, html) {
    if ((html != undefined && html.length != 0 && html != null) && (item != undefined && item != null && item.length != 0)) {
      var keys = Object.keys(item);
      for (var n = 0; n < keys.length; n++) {
        var txt = this.removeSpecialCharacters(keys[n]);
        keys[n] = txt;
        var s = html.filter(e => e.formcontrolname.toLowerCase() == keys[n])
        if ((s == undefined) || (s.length == 0)) {
          if ((keys[n] != 'Document ID') && (keys[n] != 'Created By') && (keys[n] != 'Created On') && (keys[n] != 'Form Name')) {
            // console.log(keys[n]);
            delete item[keys[n]];
            //n = n + 1;
          }
        }
      }

    }
  }

  getMasterText(masterValues, selectedValues, tablename) {
    var selectedText = '';
    if (selectedValues.length == 1) {
      if ((this._masterValues != undefined) && (this._masterValues.length != 0)) {
        this._masterValues.forEach(k => {
          var fieldName = tablename.toLowerCase() + 'id';
          var fieldValue = tablename.toLowerCase();
          if (k[fieldName] == selectedValues[0].selected) {
            selectedText = k[fieldValue];
          }
        });
      }
    }
    else {
      selectedValues.forEach(a => {
        if ((a.selected != undefined) && (a.selected != null)) {
          if ((this._masterValues != undefined) && (this._masterValues.length != 0)) {
            this._masterValues.forEach(k => {
              var fieldName = tablename.toLowerCase() + 'id';
              var fieldValue = tablename.toLowerCase();
              if (k[fieldName] == a.selected) {
                selectedText = k[fieldValue] + ',' + selectedText;
              }
            });
          }
        }
      });
      selectedText = selectedText.slice(0, -1);
    }
    return selectedText;
  }

  getUserName(userid) {
    var userName = '';
    if ((this.UserList != undefined) && (this.UserList.length != 0)) {
      var s = this.UserList.filter(e => e.userid == userid);
      if ((s != undefined) && (s.length != 0)) {
        userName = s[0].firstname;
      }
    }
    return userName;
  }

  LoadDatabase() {
    this.databaseService.getActive().subscribe(res => {
      //  let allData :any = [];
      this.dataBases = res.filter(e => e.databaseid == this.databaseId);
      if (this.dataBases.length != 0) {
        //this.databaseService.GetImage(this.dataBases[0].databaseiconpath).subscribe(res => {
        //  let objectURL = 'data:image/jpeg;base64,' + this.dataBases[0].image;
        //  this.dataBases[0].databaseicon = this.sanitizer.bypassSecurityTrustUrl(objectURL);
        //  this.databaseName = this.dataBases[0].database;
        //}, error => { });

        this.databaseName = this.dataBases[0].database;
        // this.databaseIcon =  allData[0].databaseicon;

      }
    }, err => {
      this.toastr.error('error while getting the database data ')
    });
  }

  // ViewFormRender(item: any) {
  //   var database = this.databaseId + '*' + this.databaseName;
  //   this._router.navigate(['/home/formrender'],
  //     {
  //       //queryParams: { 'formDB': database, 'data': item["documentid"], 'formConfigId': this.selectedFormConfigId, 'mode': 'View' }
  //       queryParams: { 'formDB': database, 'data': item["documentid"], 'formConfigId': this.selectedFormConfigId, 'mode': 'View', 'page': this.p }
  //     });
  // }

  ViewFormRender(item: any) {
    let database = this.databaseId + '*' + this.databaseName;
   // let a= new encryptdecrypt();  
    let queryParams = {};
    queryParams['db'] =this.enc.encryptUsingAES256(this.databaseId.toString());// this.databaseId;
    queryParams['formDB'] =this.enc.encryptUsingAES256(database.toString()); //database;
    this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview' ?   queryParams['data'] = this.enc.encryptUsingAES256(item["ACRN Doc ID"] .toString()) : queryParams['data'] = this.enc.encryptUsingAES256(item["documentid"] .toString());
    // queryParams['data'] = item["documentid"];
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.selectedFormConfigId.toString());//this.selectedFormConfigId;
    queryParams['mode'] =  this.enc.encryptUsingAES256('View');//'View';
    if (this.archiveyear != 0 && this.archiveyear != undefined) {
    queryParams['archiveyear']= this.enc.encryptUsingAES256(this.archiveyear.toString());
    }
    //queryParams['page'] = this.p;
    //queryParams['selectedgroup'] = this.by;
    //queryParams['searchdata'] = this.searchData;
    //queryParams['filterTable'] = this.filterPatchData.length > 0;
    //this.filterPatchData.length > 0 ? queryParams['filterValue'] = JSON.stringify(this.filterPatchData) : '';
    //queryParams['isCustomSearch'] = this.isCustomSearch;
    //queryParams['itemsPerPage'] = this._itemsPerPage;
    //this.isCustomSearch ? queryParams['customSearchData'] = this.customSearchData : '';
    //queryParams['selectedNodeText'] = this.selectedNodeText;




    const navigationExtras: NavigationExtras = {
      queryParams,

      state: {
        db: this.databaseId,
        formDB: database,
        data: this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview' ? item["ACRN Doc ID"] : item["documentid"],
        formConfigId: this.selectedFormConfigId,
        mode: 'View',
        page: this.p,
        selectedgroup: this.by,
        searchdata: this.searchData,
        filterTable: this.filterPatchData.length > 0,
        filterValue: this.filterPatchData.length > 0 ? JSON.stringify(this.filterPatchData) : '',
        isCustomSearch: this.isCustomSearch,
        itemsPerPage: this._itemsPerPage,
        customSearchData: this.isCustomSearch ? this.customSearchData : '',
        selectedNodeText: this.selectedNodeText,
        subPage: this.subPage,
        team:this.by,
        columnsearchname: JSON.stringify(this.headers),
        columnsearchgroup: JSON.stringify(this._columnsearchgroup),
        isSort: this.isSort,
        sortingconditionValue: this.colkey,
        sortDirectionValue: this.sortDirection,
        customSearchSortConditionValue: this.sortingcondition,
        selectedNodeValue: this.selectedNodeValue,
        archiveyear: this.archiveyear,
        groupleveldata: this.groupleveldata,
        countConditionObj: JSON.stringify(this.countConditionObj),
        getvaluesConditionObj: JSON.stringify(this.getvaluesConditionObj),
        isadvancesearch: this.isadvancesearch

      }
    };

    this._router.navigate(['/home/formrender'], navigationExtras);
  }

  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [month, day, year].join('/');
  }

  //method to open the modal popup
  openModal(item: any) {
    var config: ModalOptions = {
      backdrop: 'static',
      keyboard: false,
      animated: true,
      ignoreBackdropClick: false,
      class: 'modal-lg',
      initialState: {
        _dbidFromDashboard: this.databaseId + '*' + this.databaseName,
        _formDataFromDashboard: item
      }
    }
    this.bsModalRef = this.modalService.show(FormrenderComponent, config);
    this.bsModalRef.content.closeBtnName = 'Close';
  }

  //method to open form render
  openFormRender(item: any) {
    var database = this.databaseId + '*' + this.databaseName;
  // let a= new encryptdecrypt();  
    var _database= this.enc.encryptUsingAES256(database.toString());
    var itemDocument= this.enc.encryptUsingAES256(item["documentid"].toString());
    var _selectedFormConfigId= this.enc.encryptUsingAES256(this.selectedFormConfigId.toString());
    var _page= this.enc.encryptUsingAES256(this.p.toString());
    var _archiveyear= this.enc.encryptUsingAES256(this.archiveyear.toString());
    this._router.navigate(['/home/formrender'],
      {
        //queryParams: { 'formDB': database, 'data': item["documentid"], 'formConfigId': this.selectedFormConfigId }
        queryParams: { 'formDB': _database, 'data': itemDocument, 'formConfigId': _selectedFormConfigId, 
        'page': _page, 'archiveyear': _archiveyear }
      });
  }

  async onSelectedChange(item) {
	this.searchbyallocation=item.text;											  
    this.sortingcondition = '';
    this.colkey = '';
    this.p = 1;
    this._selectedItems = [];
    this._columnsearchgroup = [];
    this.headers = [];
    this.selectedStartDate = '';
    this.columnshow = false;
    this.isCustomSearch = false;
    this.isSort = false;
    this.isSortGroupBy = false;
    this.selectedgroup = '';
    this.headersgroup = [];
    this.groupByFromRender = false;
    this.searchData = '';
    this._columnsearchgroupformrender = [];
    this.previewfilterflag = false;
    let str: string;
    this.advancedSearchEditMode = false;
    this.columnsearch = false;
    if (this.entry.length > 0) {
      this.entry.forEach(container => {
        container.viewContainerRef.clear();
      });
    }
    str = item.value;

    this.advancedSearchId = 0;
    this.filternameTxt = '';
    this.showAllChecked = false;
    if (item.value != undefined) {
      var s = str.toString().split('*');
      this.fieldgroupListadded = [];
      if (s.length == 1) {

        var data = this.list.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == item.value);
        if (data != undefined && data != null && data.length != 0) {
          this.selectedNodeText = item.text;
          this.selectedNodeValue = item.value;
          this.customSearchEnable = false;
          if (item.text == data[0].formconfigname) {
            this.LoadSearchedFormDetails(data[0], 'All', '', 1, 0);
            this.showFormFields(data[0], this.selectedFormConfigId);
          }
          else
            this.LoadSearchedFormDetails(data[0], item.text, '', 1, 0);
        }
      }
      else if (s[0] == 'customsearch') {
        this.p = this.isCustomSearch && this.customSearchValue != undefined && this.customSearchValue != '' && this.customSearchValue != null ? (item.value == JSON.parse(this.customSearchValue)['value'] ? this.p : 1) : 1;
        this.isCustomSearch = true;
        this.customSearchData = JSON.stringify(item);
        this.selectedNodeText = item.text;
        this.selectedNodeValue = item.value;
        // this.columnsearch = true;
        this.customSearchEnable = true;
        this.advancedSearchId = +s[1];
        // this.showAdvancedSearch(this.advancedSearchId, 1, null);
        this.showAdvancedSearch(this.advancedSearchId, this.p, null);
      }
      else {
        this.isCustomSearch = false;
        var data = this.list.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == s[1]);
        if (data != undefined && data != null && data.length != 0) {
          this.selectedNodeText = item.text;
          this.selectedNodeValue = item.value;
          this.LoadSearchedFormDetails(data[0], s[0], '', 1, 0);
          this.showFormFields(data[0], this.selectedFormConfigId);
        }
      }
    }

  }

  showFormDatabasedoOnSelection(data) {
    this.by = '';
    this.searchData = '';
    var _searchData = '';
    if (data.length != 0) {
      data.forEach(i => {
        var s = i.split('->');
        var _formConfigID = s[0].trim();
        this.formconfigidnewsletter = _formConfigID;
        var by = '';
        by = s[1].trim();
        this.by = by;
        if (s[2] != undefined && s[2].length != 0) {
          var a = s[2].split(':');
          _searchData = a[0].trim();
          this.searchData = _searchData;
        }
        var data = this.list.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == _formConfigID);
        //  console.log(data[0]);
        if (data != undefined && data != null && data.length != 0) {
          this.LoadSearchedFormDetails(data[0], this.by, this.searchData, this.p, 0);
          this.showFormFields(data[0], data[0].formconfigid);
        }

      });
    }

  }

  //getPage(page: number) {
  //  this.p = page;
  //  this.pageevent = true;
  //  if (this.sortingcondition == '') {
  //    if (this.advancedSearchId == 0) {
  //      if (this.columnshow == true)
  //        this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
  //      else
  //      this.Loadformdetails(page);
  //    }      
  //    else {        
  //        this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
  //    }
  //  }
  //  else {
  //    this.sorting(this.colkey, 1);
  //  }

  //}
  getPage(page: number) {
    this.p = page;
    this.markallcheckbox = false;
    this.pageevent = true;
    if (this.sortingcondition != '') {
      this.sorting(this.colkey, 1);
    }
    if (this.sortingcondition == '') {
      if (this.columnshow == true) {
        // this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
        if (this._columnsearchgroup != undefined && this._columnsearchgroup.length != 0) {
          this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
        }

        else {
          if (this.advancedSearchId == 0) {
            if (this.previewfilterflag == false)
              this.Loadformdetails(page);
            else
              this.previewFilter(page);
          }
          else {
            this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
          }
        }
      }
      else {

        if (this.advancedSearchId == 0) {
          if (this.previewfilterflag == false)
            this.Loadformdetails(page);
          else
            this.previewFilter(page);
        }
        else {
          this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
        }
      }
    }

  }
  getgroupPage(page: number) {
    //if (page != 1) {
    this.p = page;
    this.Loadformdetails(page);
    //}
  }

  getCustomPage(page: number) {
    if (this.sortingcondition == '') {
      this.p = page;
      if (this.customSearchDocumentList.length != 0 && this.rowsData.length == 0)
        this.showAdvancedSearch(this.advancedSearchId, page, null);
    }
    else {
      this.p = page;
      this.pageevent = true;
      // this.sortingcusto(this.colkey, 1);
    }
  }

  LoadSearchedFormDetails(item: formconfig, by, searchData, pagenumber, columnsearchflag) {
    var searchcondition = "";
    this.by = by;
    var searchcountcondition = "";
    if (by == "All") {
      searchcondition = "All";
      searchcountcondition = "All";
      this.groupRowsBy = "All";
      this.loaddetails(item, by, searchData, pagenumber, searchcondition, searchcountcondition);
    }
    else if (by == "createdon") {
      searchcondition = "createdon";
      searchcountcondition = "createdon";
      this.groupRowsBy = "createdon";
      this.loaddetails(item, by, searchData, pagenumber, searchcondition, searchcountcondition);
    }
    else if (by == "createdby") {
      searchcondition = "createdby";
      searchcountcondition = "createdby";
      this.groupRowsBy = "createdby";
      this.loaddetails(item, by, searchData, pagenumber, searchcondition, searchcountcondition);
    }
    else {

      
      if (columnsearchflag == 1) {

        searchcondition = searchData;
        searchcountcondition = searchData;
      }
      else {
        searchcondition = by;
        searchcountcondition = by;
        this.groupRowsBy = by;
      }

      if (this.groupleveldata != '')
        this.loaddetailssecondlevel(item, by, searchData, pagenumber, searchcondition, searchcountcondition);
      else
        this.loaddetails(item, by, searchData, pagenumber, searchcondition, searchcountcondition);
    }
  }

  loaddetails(item: formconfig, by, searchData, pagenumber, searchcondition, searchcountcondition) {
    this.SpinnerService.show();
    this.customSearchDocumentList = [];
    this.headers = [];
    this.allAdvancedSearchList = [];
    this.initialRowDataList = [];
    this.formconfigidnewsletter = item.formconfigid;
    this.selectedFormConfigId = item.formconfigid;
    // this.loadFilter();
    this.formConfigName = item.formconfigname;
    let allFormConfigData: any = []; let _documentList: any = [];
    // this.totalformdetailcount = 0;
    let input: any = [];

    if (this.searchTextforDatabase != '' && this.searchTextforDatabase != undefined && this.searchbyallocation == 'By Allocation') {
      input.push({
        'formconfigid': item.formconfigid, 'searchcondition': searchcountcondition + '*' + this.searchTextforDatabase, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
      })
        
    }
    else {

      input.push({
        'formconfigid': item.formconfigid, 'searchcondition': searchcountcondition, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
      })
    }
    

    this.countConditionObj = input[0];
    //this.formdashboardservice.getFormConfig().subscribe(
    //  (result) => {
    //    if (result != undefined) {
    //      this.formConfigList = [];
    //      this.formConfigList = result.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId);
    //    }
    
    this.formdashboardservice.getAllFormDocumentDetailscount(input[0]).subscribe(
      (res) => {
        this.totalformdetailcount = res.body.count;
        if (res.body.count > 0) {
          this.p = pagenumber;
          let obj: any = [];
          if (this.searchTextforDatabase != '' && this.searchTextforDatabase != undefined  && this.searchbyallocation == 'By Allocation') {
            obj.push({
              'formconfigid': item.formconfigid, 'pageno': pagenumber, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition + '*' + this.searchTextforDatabase , 'userid': this.userid, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
            })

          }
          else {

            obj.push({
              'formconfigid': item.formconfigid, 'pageno': pagenumber, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition, 'userid': this.userid, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
            })
          }

          this.getvaluesConditionObj = obj[0];
          this.isadvancesearch = false;
          this.formdashboardservice.getAllFormDocumentDetails(obj[0]).subscribe(
            async (res) => {
              // console.log(res);
              if (res != undefined && res != null && res.length != 0) {

                if (this.state != null && this.state != undefined) {
                  if (this.state.groupleveldata != null && this.state.groupleveldata != '' && this.state.groupleveldata != undefined) {

                  }
                  else
                    this.rowsData = [];
                }
                else
                  this.rowsData = [];

                _documentList = JSON.parse(res.body[0].j);
                if (_documentList != undefined && _documentList != null && _documentList.length != 0) {
                  _documentList.map(function (obj) { delete obj.createdby; delete obj.createdon; delete obj.formconfigid });
                  //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
                  //let html = formConfigField.filter(x => x.displaystatus == 1);
                  //html.forEach(element => {
                  //  element['label'] = element.name;
                  //});
                  var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
                  let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
                  var _headers = Object.keys(_documentList[0]);
                  this.headers = [];
                  _headers.forEach(i => {
                    //if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                    //  && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                    //  && (i.toString() != "groupname")
                    //  && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                    //) {
                    //  var f = htmldata.filter(e => e.label == i)[0].type;
                    //  if (f.length != 0) {
                    //    this.headers.push({
                    //      columnname: i,
                    //      columntype: f,
                    //      searchname: ''
                    //    });
                    //  }
                    //  else {
                    //    this.headers.push({
                    //      columnname: i,
                    //      columntype: 'text',
                    //      searchname: ''
                    //    });
                    //  }
                    //}
                   // 
                    var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"));
                    if ((f.length != 0) && (this.by != 'teamallocation') && (this.by != 'teamallocationreview') && this.by != 'teamallocationnotreview') {
                      if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                        && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                        && (i.toString() != "groupname")
                        && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                        && (i.toString() != "requestdetails") && (i.toString() != "vieweduserdetails")
                        &&  (i.toString() != "eutitletooltip")
                      ) {
                        this.headers.push({
                          columnname: i,
                          columntype: f[0].type,
                          searchname: ''
                        });
                      }
                      else {
                        this.headers.push({
                          columnname: i,
                          columntype: 'text',
                          searchname: ''
                        });
                      }
                    }
                    else {
                      if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by== 'teamallocationnotreview') {
                        if (i.toString() == 'Created Date') {
                          this.headers.push({
                            columnname: i,
                            columntype: 'date',
                            searchname: ''
                          });
                        }
                        else if (i.toString() == 'File Name') {
                          this.headers.push({
                            columnname: i,
                            columntype: 'file',
                            searchname: ''
                          });
                        }
                        else {
                          this.headers.push({
                            columnname: i,
                            columntype: 'text',
                            searchname: ''
                          });
                        }
                      }
                    }

                  });


                  this._colspan = this.headers.length
                  var list = _documentList;
                  this.initialRowDataList = list;
                  if (by == 'All' || by == 'teamallocation' || by == 'teamallocationreview' || by == 'teamallocationnotreview') {//without groupby //code to handle team allocation - || by == 'teamallocation'
                    this.rowsData = [];
                    this.rowsData = list;
                    this.groupSearch = false;
                    this.groupExpansionDefault = false;

                  }
                  if (by != 'All' && searchData != '') { //search data for column search
                    this.rowsData = [];
                    this.rowsData = list;
                    this.groupSearch = false;
                    this.groupExpansionDefault = false;

                  }

                  if (by != 'All' && searchData == '' && by != 'teamallocation' && by != 'teamallocationreview' && by != 'teamallocationnotreview') { //group by //code to handle team allocation -  && by != 'teamallocation'
                    this.groupByList = [];                   
                    this.rowsData = [];                   
                    this.innerRowsData = [];
                    this.groupSearch = true;
                    this.groupExpansionDefault = false;

                    if (this.groupleveldata != '') {

                      list.forEach(i => {
                        if (i.groupname != undefined && i.groupname != null) {
                          var data = i.groupname.split('*');
                          if (data != null && data != undefined && data[1] != undefined) {//&& data[0] != ''
                            this.innerRowsData.push(
                              {
                                groupname: data[0],
                                read: false
                              });
                          }
                          else {
                            this.innerRowsData.push(
                              {
                                groupname: i.groupname,
                                read: true
                              });
                          }
                        }
                        else {
                          this.innerRowsData.push(
                            {
                              groupname: i.groupname,
                              read: true
                            });
                        }
                      });


                     
                    }
                   
                    if (this.groupleveldata == '') {
                      list.forEach(i => {
                        if (i.groupname != undefined && i.groupname != null) {
                          var data = i.groupname.split('*');
                          if (data != null && data != undefined && data[1] != undefined) {//&& data[0] != ''
                            this.rowsData.push(
                              {
                                groupname: data[0],
                               
                                read: false
                              });
                          }
                          else {
                            this.rowsData.push(
                              {
                                groupname: i.groupname,
                                read: true
                              });
                          }
                        }
                        else {
                          this.rowsData.push(
                            {
                              groupname: i.groupname,
                              read: true
                            });
                        }
                      });
                     
                      this.groupleveldata = ''; 
                    }
                    
                   
                   
                    //if (searchcondition == 'modifiedon') {
                    //  list.forEach((i, ind) => {
                    //    this.rowsData.push(
                    //      {
                    //        groupname: this.datePipe.transform(i.groupname, "yyyy/dd/MM")
                    //      });
                    //  });
                    //}
                    //else {
                    //  list.forEach((i, ind) => {
                    //    this.rowsData.push(
                    //      {
                    //        groupname: i.groupname
                    //      });
                    //  });
                    //}


                  }
                  if (by != 'teamallocation' && by != 'teamallocationreview' && by != 'teamallocationnotreview') {
                    
                    var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                    if (decissiondateindex !== -1) {
                      var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                      this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                      decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                      this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                      }
                  }
                  this.SpinnerService.hide();
                  this.rowsData.forEach(element => {
                    if (element.read) {
                      element['isReadCheck'] = null;
                    } else {
                      element['isReadCheck'] = false;
                    }
                  });
                  if (this.state != null && this.state != undefined) {
                    if (this.state.groupleveldata != null && this.state.groupleveldata != '' && this.state.groupleveldata != undefined) {
                      this.groupleveldata = this.state.groupleveldata;
                      this.groupleveldataname = this.state.groupleveldata;
                      var searchsplitdata = this.searchData.split(':');
                      this.groupname2 = searchsplitdata[0];
                      this.backcourtsearchData = searchsplitdata[1];
                      this.state.groupleveldata = '';
                      this.Loadformdetails(1);

                    }
                  }
                }
                else {
                  this.headers = [];
                  this.rowsData = [];
                  this.SpinnerService.hide();
                }

              }
              else {
                this.headers = [];
                this.rowsData = [];
                this.SpinnerService.hide();
               
              }

            },
            err => {
              this.toastr.error('Not able to get dashboard data');
              this.SpinnerService.hide();
              this.headers = [];
              this.rowsData = [];
            });
        }
        else {

          this.SpinnerService.hide();
          this.headers = [];
          this.rowsData = [];
        }
      });

    //});

  }




  loaddetailssecondlevel(item: formconfig, by, searchData, pagenumber, searchcondition, searchcountcondition) {
    this.SpinnerService.show();    
    // this.loadFilter();
    this.formConfigName = item.formconfigname;
    this.innerRowsData = [];
    let allFormConfigData: any = []; let _documentList: any = [];
    // this.totalformdetailcount = 0;
    let input: any = [];
    input.push({
      'formconfigid': item.formconfigid, 'searchcondition': searchcountcondition, 'sorting': null, 'groupleveldata': this.groupleveldata,'archiveyear': this.archiveyear
    })
    this.countConditionObj = input[0];
    this.formdashboardservice.getAllFormDocumentDetailscount(input[0]).subscribe(
      (res) => {
        this.totalformdetailcount = res.body.count;
        if (res.body.count > 0) {         
          let obj: any = [];
          obj.push({
            'formconfigid': item.formconfigid, 'pageno': pagenumber, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition, 'userid': this.userid, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
          })
          this.getvaluesConditionObj = obj[0];
          this.isadvancesearch = false;
          this.formdashboardservice.getAllFormDocumentDetails(obj[0]).subscribe(
            async (res) => {
              // console.log(res);
              if (res != undefined && res != null && res.length != 0) {
                
                _documentList = JSON.parse(res.body[0].j);
                if (_documentList != undefined && _documentList != null && _documentList.length != 0) {                                                      
                  var list = _documentList;                                   
                  if (by != 'All' && searchData == '' && by != 'teamallocation' && by != 'teamallocationreview' && by != 'teamallocationnotreview') { //group by //code to handle team allocation -  && by != 'teamallocation'
                   
                    if (this.groupleveldata != '') {

                      list.forEach(i => {
                        if (i.groupname != undefined && i.groupname != null) {
                          var data = i.groupname.split('*');
                          if (data != null && data != undefined && data[1] != undefined) {//&& data[0] != ''
                            this.innerRowsData.push(
                              {
                                groupname: data[0],
                                read: false
                              });
                          }
                          else {
                            this.innerRowsData.push(
                              {
                                groupname: i.groupname,
                                read: true
                              });
                          }
                        }
                        else {
                          this.innerRowsData.push(
                            {
                              groupname: i.groupname,
                              read: true
                            });
                        }
                      });

                    }
                    this.groupleveldata = '';
                  }
                  this.SpinnerService.hide();
                }
                else {                 
                  this.SpinnerService.hide();
                }

              }
              else {
               
                this.SpinnerService.hide();
              }

            },
            err => {
              this.toastr.error('Not able to get dashboard data');
              this.SpinnerService.hide();
             
            });
        }
        else {
          this.SpinnerService.hide();         
        }
      });

    //});

  }







  _getSearchFieldsNamecolumn(byName) {
    var resulttxt = '';
    if (this.formSearchDetailsListfield != undefined && this.formSearchDetailsListfield != null && this.formSearchDetailsListfield.length != 0) {


      var searchfields = this.formSearchDetailsListfield[0].formsearchdetails.split(',');
      if (searchfields != undefined && searchfields != null && searchfields.length != 0) {
        searchfields.forEach(i => {
          var j = i.split('*');
          if (j.length != 0) {
            if (byName == j[1].trim()) {
              //if (j[0].trim() == 'Created By' || j[0].trim() == 'Created On')
              resulttxt = j[0].trim();
              //else {
              //resulttxt = byName;
              //}
            }
          }
        });
      }

    }
    return resulttxt;
  }


  _getSearchFieldsName(byName) {
    var resulttxt = '';
    if (this.formSearchDetailsList != undefined && this.formSearchDetailsList != null && this.formSearchDetailsList.length != 0) {
      var allData = this.formSearchDetailsList.map(m => { return JSON.parse(m['spformsearchdetails']); });
      var d = allData.filter(e => e.formconfigid == this.selectedFormConfigId);
      if (d != undefined && d.length != 0 && d != null) {
        var searchfields = d[0].searchFields.split(',');
        if (searchfields != undefined && searchfields != null && searchfields.length != 0) {
          searchfields.forEach(i => {
            var j = i.split('*');
            if (j.length != 0) {
              if (byName == j[1].trim()) {
                if (j[0].trim() == 'Created By' || j[0].trim() == 'Created On')
                  resulttxt = j[0].trim();
                else {
                  resulttxt = byName;
                }
              }
            }
          });
        }
      }
    }
    return resulttxt;
  }


  search(list, by, searchdata) {
    var s = [];
    var _searchTxt = '';
    _searchTxt = this._getSearchFieldsName(by);
    if (list != undefined && list != null && list.length != 0)
      s = list.filter(e => e[_searchTxt].toLowerCase().includes(searchdata.toLowerCase()));
    return s;
  }



  //datatable group by

  onDetailToggle(event) {
    //console.log('Detail Toggled', event);
  }

  toggleExpandRow(row) {
    //console.log('Toggled Expand Row!', row);
    this.table.rowDetail.toggleExpandRow(row);
  }

  toggleExpandGroup(group) {
    // console.log('Toggled Expand Group!', group);
    this.table.groupHeader.toggleExpandGroup(group);
  }
  //advanced search
  //author button click
  openAuthor() {
    if (this.authorDiv == true)
      this.authorDiv = false;
    else
      this.authorDiv = true;

  }
  //forms button click
  openForms() {
    if (this.FormDiv == true)
      this.FormDiv = false;
    else
      this.FormDiv = true;
  }
  //form fields button click
  async openFormFields() {
    if (this.selectedFormId != '') {
      if (this.FormFieldsDiv == true) {
        //load the form fields value
        // var htmldata = JSON.parse(this.list.filter(e => e.formconfigid == this.selectedFormId)[0].htmldata);
        //let formConfigField = await this.getFormDisplayField(this.selectedFormId);
        //let html = formConfigField.filter(x => x.displaystatus == 1);
        //html.forEach(element => {
        //  element['label'] = element.name;
        //});
        let htmlvalue = JSON.parse(this.list.filter(e => e.formconfigid == this.selectedFormId)[0].htmldata);
        let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
        if (htmldata != undefined && htmldata != null && htmldata.length != 0) {
          htmldata.forEach(i => {
            this.formFieldsListTmp.push({ formfieldsid: i + 1, formfields: i.label });
          });
          this._dropdownSettingsform = {
            singleSelection: false,
            idField: 'formfieldsid',
            textField: 'formfields',
            selectAllText: 'Select All',
            unSelectAllText: 'UnSelect All',
            itemsShowLimit: 7,
            allowSearchFilter: true
          };
          this.formFieldsListTmp = this.formFieldsListTmp.sort((a, b) => a.formfields.localeCompare(b.formfields));
          this.formFieldsList = JSON.parse(JSON.stringify(this.formFieldsListTmp));

        }
        this.FormFieldsDiv = false;
      }
      else
        this.FormFieldsDiv = true;
    }
    else {
      this.toastr.error('Please select the form name');
      return;
    }
  }
  //form config drop down

  changeFormConfig(eve) {
    this.selectedFormId = eve.currentTarget.value;
    this.formFieldsListTmp = [];
    this.formFieldsList = [];
    // this.openFormFields();
  }


  changefieldsconditions(eve, i) {
    if (this.fieldgroupListadded[i]['fieldstype'] != 'date') {
      if (eve.currentTarget.value == 1)
        this.fieldgroupListadded[i]['condition'] = 1;
      else
        this.fieldgroupListadded[i]['condition'] = 2;
    }
    if (this.fieldgroupListadded[i]['fieldstype'] == 'date') {
      if (eve.currentTarget.value == 1)
        this.fieldgroupListadded[i]['condition'] = 1;
      else
        this.fieldgroupListadded[i]['condition'] = 2;
    }
  }


  async changeFormfields(eve, i) {
    let fieldValue = this.fieldgroupListadded.filter(x => x.fieldsname == eve.target.value);
    if (fieldValue.length > 1) {
      this.toastr.warning('Condition already exists');
      let fId = this.fieldgroupListadded[i].fieldsid;
      this.fieldgroupListadded[i] = {
        fieldsid: fId,
        fieldsname: 'Select Field Name',
        condition: 0,
        fieldeditmode: false,
        removed: false
      };
      return;
    }
    var formcontrolname = eve.currentTarget.value;
    if (this.formConfigList != undefined && this.formConfigList != null && this.formConfigList.length != 0) {
      // var htmldata = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
      //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
      //let html = formConfigField.filter(x => x.displaystatus == 1);
      //html.forEach(element => {
      //  element['label'] = element.name;
      //});
      let htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
      let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
      if (htmldata.length != 0) {
        var _type = htmldata.filter(m => m.type != 'hidden' && m.type != 'header' && m.type != 'paragraph' && m.formcontrolname.toLowerCase() == formcontrolname.toLowerCase())[0].type;
        var _label = htmldata.filter(m => m.type != 'hidden' && m.type != 'header' && m.type != 'paragraph' && m.formcontrolname.toLowerCase() == formcontrolname.toLowerCase())[0].label;
        var _tablename = htmldata.filter(m => m.type != 'hidden' && m.type != 'header' && m.type != 'paragraph' && m.formcontrolname.toLowerCase() == formcontrolname.toLowerCase())[0].tablename;
        if (_type != undefined && _type != null && _type != '') {
          this.fieldgroupListadded[i]['fieldsname'] = formcontrolname.toLowerCase();
          this.fieldgroupListadded[i]['fieldstype'] = _type;
          this.fieldgroupListadded[i]['label'] = _label;
          this.fieldgroupListadded[i]['fieldeditmode'] = true;
          this.fieldgroupListadded[i].condition = 0;
          this.fieldgroupListadded[i].value = '';
          this.selectedfieldDate[i] = [];
          if (_tablename != undefined && _tablename != null)
            this.fieldgroupListadded[i]['tablename'] = _tablename;
          else
            this.fieldgroupListadded[i]['tablename'] = '';
          this.fieldgroupListadded[i]["removed"] = false;

        }
      }
    }
  }

  //adding fields in the table
  addItem() {

    if (this.fieldgroupListadded.filter(e => e.removed != true && (e.fieldsname == 'Select Field Name' || e.fieldsname != 'Select Field Name') && (e.value == undefined || e.value == '')).length != 0) {
      this.toastr.error("Fields need to select and values cannot be empty");
      return;
    }
    else {
      var s = this.fieldgroupList.length;
      var currentElement = this.fieldgroupList[s];
      this.fieldgroupList.splice(s, 0, currentElement)

      this.fieldgroupListadded.push({
        fieldsid: s, fieldsname: 'Select Field Name', condition: 0, fieldeditmode: false, removed: false
      });

      if (this.fieldgroupListadded.filter(e => e.removed != true && e.fieldsname == 'Select Field Name').length != 0) {
        var list = this.fieldgroupListadded.filter(e => e.removed != true && e.fieldsname != 'Select Field Name');
        if (list.length < this.selectedFormFields.length - 1) {
          this.addFormFields = true;
        }
        else
          this.addFormFields = false;
      }
      else {
        var list = this.fieldgroupListadded.filter(e => e.removed != true && e.fieldsname != 'Select Field Name');
        if (list.length < this.selectedFormFields.length) {
          this.addFormFields = true;
        }
        else
          this.addFormFields = false;
      }
    }
  }

  //remove selected table td
  removeTD(eve, i) {
    this.fieldgroupListadded.splice(i, 1);
    // var td = eve.target.parentNode;
    // var tr = td.parentNode;
    // tr.parentNode.removeChild(tr);
    // this.fieldgroupListadded[i]["removed"] = true;
    this.addFormFields = true;

  }

  //save filter
  saveFilter() {
    let formAdvancedSearch = new FormDashboard;
    var _groupAuthorText = {}; var _groupFieldsText = {}; var groupFieldsCondition = {};
    formAdvancedSearch.active = 1;
    formAdvancedSearch.advancedsearch = this.filternameTxt.trim();
    formAdvancedSearch.formconfigid = this.selectedFormConfigId;
    //formAdvancedSearch.createdby = +localStorage.getItem('userid');
    formAdvancedSearch.createdby = +this.localService.getJsonValue('userid');
    //formAdvancedSearch.userid = +localStorage.getItem('userid');
    formAdvancedSearch.userid = +this.localService.getJsonValue('userid');
    if (this.selectedStartDate != undefined && this.selectedStartDate != null && this.selectedStartDate.length != 0)
      formAdvancedSearch.daterange = this.datePipe.transform(this.selectedStartDate[0], "MM/dd/yyyy") + '-' + this.datePipe.transform(this.selectedStartDate[1], "MM/dd/yyyy");
    if (this._selectedItems != undefined && this._selectedItems != null && this._selectedItems.length != 0) {
      _groupAuthorText['author'] = this._selectedItems.map(e => { return e.authorId });
      formAdvancedSearch.author = JSON.stringify(_groupAuthorText);
    }
    else
      formAdvancedSearch.author = null;
    if (this.selectedFormFields != undefined && this.selectedFormFields != null && this.selectedFormFields.length != 0) {
      _groupFieldsText['fieldsname'] = this.selectedFormFields.map(e => { return e.formfieldsid });
      formAdvancedSearch.fieldsname = JSON.stringify(_groupFieldsText);
    }
    else
      formAdvancedSearch.fieldsname = null;
    //console.log(formAdvancedSearch);
    if (this.fieldgroupListadded != undefined && this.fieldgroupListadded != null && this.fieldgroupListadded.length != 0) {
      var fieldscondition = this.fieldgroupListadded.filter(e => e.removed != true && e.fieldsname != 'Select Field Name');
      fieldscondition.forEach(i => {
        if (i.fieldstype != 'date') {
          if (i.condition == 1)
            i.condition = 'Equals';
          else
            i.condition = 'Contains';
        }
        if (i.fieldstype == 'date') {
          if (i.condition == 1)
            i.condition = 'Equals';
          else
            i.condition = 'Between';
        }
      });
      fieldscondition.map(function (obj) { delete obj.fieldsid; delete obj.fieldeditmode; });
      if (this.selectedStartDate != undefined && this.selectedStartDate != null && this.selectedStartDate.length != 0) {
        fieldscondition.push({ fieldsname: 'createdon', condition: 'Between', fieldstype: 'date', label: 'createdon', value: formAdvancedSearch.daterange });
      }
      if (this._selectedItems != undefined && this._selectedItems != null && this._selectedItems.length != 0) {
        fieldscondition.push({ fieldsname: 'createdby', condition: 'contains', fieldstype: 'text', label: 'createdby', value: JSON.stringify(_groupAuthorText['author']) });
      }
      groupFieldsCondition['FieldsCondition'] = fieldscondition;
      formAdvancedSearch.fieldscondition = JSON.stringify(groupFieldsCondition);
    }
    else {
      formAdvancedSearch.fieldscondition = null;
    }
    formAdvancedSearch.showforall = this.showStatus;
    var model = [];
    model.push({
      data: formAdvancedSearch, name: this.filternameTxt.trim()
    });
    if (this.userSelectedFilter == '') {
      this.toastr.error("Filter condition cannot be empty");
      return;
    }
    if (this.filternameTxt.trim() == '') {
      this.toastr.error("search name cannot be empty");
      return;
    }
    $("#btnloadfilter").prop('disabled', 'true');
    if (this.filternameTxt.trim() != '' && (this.userSelectedFilter != '')) {
      this.formdashboardservice.insertAdvancedSearch(model[0]).subscribe(res => {
        if (res.body != 0) {
          this.toastr.success("Filter data inserted successfully");
          this.selectedStartDate = []; this.selectedFormFields = []; this._selectedItems = []; this.userSelectedFilter = ''; this.filternameTxt = ''; this.showStatus = 0;
          $('#showalluser')[0].checked = false;
          //this.formSearchDetails();
          this.Loadtree();
          this.rowsData = [];
          this.customSearchDocumentList = [];
          this.customSearchHeaders = [];
          this.headers = [];
          this.Loadformdetails(1);
          this.fieldgroupListadded = [];
          $("#btnloadfilter").removeAttr('disabled');
        }
        else {
          this.toastr.error("Filter name already exists");
          $("#btnloadfilter").removeAttr('disabled');
        }
      });
    }
    else {
      this.toastr.error("search name or Filter condition cannot be empty");
      $("#btnloadfilter").removeAttr('disabled');
      return;
    }
  }



  selectedValue() {
    // this.loadFilter();
    var authorText = ''; var formfields = ''; this.userSelectedFilter = '';
    if (this.fieldgroupListadded != undefined && this.fieldgroupListadded != null && this.fieldgroupListadded.length != 0) {
      this.fieldgroupListadded.forEach(i => {
        if (i.fieldsname != undefined && i.fieldsname != '' && i.fieldstype != 'date') {
          if ($('#' + i.fieldsname)[0].value != undefined) {
            var txt = $('#' + i.fieldsname)[0].value;
            if (txt != '')
              i['value'] = txt;
            else
              i['value'] = '';
          }
        }

      });
    }
    if (this._selectedItems != undefined && this._selectedItems != null && this._selectedItems.length != 0) {
      var s = this._selectedItems.map(e => { return e.authorName });
      if (s.length != 0) {
        s.forEach(i => {
          authorText = i + ' ' + authorText;
        });
      }
      this.userSelectedFilter = this.userSelectedFilter + 'Choosed Author: ' + authorText;
    }
    if (this.selectedFormFields != undefined && this.selectedFormFields != null && this.selectedFormFields.length != 0) {
      var u = this.selectedFormFields.map(e => { return e.formfields });
      if (u.length != 0) {
        u.forEach(i => {
          formfields = i + ' ' + formfields;
        });
      }
      this.userSelectedFilter = this.userSelectedFilter + 'Choosed fields: ' + formfields;
    }
    if (this.selectedStartDate != undefined && this.selectedStartDate != null && this.selectedStartDate.length != 0)
      this.userSelectedFilter = this.userSelectedFilter + 'Choosed date: ' + this.datePipe.transform(this.selectedStartDate[0], "MM/dd/yyyy") + '-' + this.datePipe.transform(this.selectedStartDate[1], "MM/dd/yyyy");

  }

  updateMyDate(eve) {
    this.columnsearchchanged();
  }

  //showformFields
  async showFormFields(list, formconfigid) {
    this.formFieldsListTmp = [];
    this.selectedFormFields = [];
    if (list != undefined && list != null && list.length != 0) {
      //let formConfigField = await this.getFormDisplayField(list.formconfigid);
      //let html = formConfigField.filter(x => x.displaystatus == 1);
      //html.forEach(element => {
      //  element['label'] = element.name;
      //});
      let htmlvalue = JSON.parse(list.htmldata);//JSON.parse(list.filter(e => e.formconfigid == formconfigid)[0].htmldata);
      let htmldata = htmlvalue;//html.length > 0 ? html : htmlvalue;
      if (htmldata != undefined && htmldata != null && htmldata.length != 0) {
        htmldata.forEach((i, ind) => {
          if (i.type != 'hidden' && i.type != 'header' && i.type != 'paragraph')
            this.formFieldsListTmp.push({ formfieldsid: i.formcontrolname.toLowerCase(), formfields: i.label });
        });
        this.formFieldsListTmp = this.formFieldsListTmp.sort((a, b) => a.formfields.localeCompare(b.formfields));
      }
    }
  }
  //load all the user created search list
  loadFilter() {
    this.allAdvancedSearchList = [];
    this.formdashboardservice.getAllAdvancedSearch().subscribe(res => {
      if (res != undefined) {
        //this.allAdvancedSearchList = res.filter(e => e.createdby == localStorage.getItem('userid') && e.formconfigid == this.selectedFormConfigId && e.dbid == this.databaseId);
        this.allAdvancedSearchList = res.filter(e => e.createdby == this.localService.getJsonValue('userid') && e.formconfigid == this.selectedFormConfigId && e.dbid == this.databaseId);
      }

    })
  }
  //

  showAdvancedSearch(searchId, pageno, sorting) {
    this.SpinnerService.show();
    this.groupByList = [];
    this.advancedSearchEditMode = true;
    let fieldsconditiontext: any = []; let filteredlist: any = [];
    this.customSearchDocumentList = []; this.customSearchHeaders = [];
    this.previewFlag = true;
    this.formdashboardservice.getadvancedsearchById(searchId).subscribe(result => {
      if (result != undefined && result != null && result.length != 0)
        this.advancedSearchValuesLoad(result);
    });

    let formdata: any = [];
    formdata.push({
      advancedSearchId: searchId,
      pageno: pageno,
      itemsperpage: this.itemsPerPageText,
      userid: this.userid,
      sorting: sorting,
      archiveyear: this.archiveyear
    });
    this.countConditionObj = formdata[0];
    
    this.formdashboardservice.getformadvancedsearchdetailscount(formdata[0]).subscribe(res => {
      if (res != undefined && res != null) {
        this.totalformdetailcount = JSON.parse(res.body[0].formdetails)[0].count;
      }
      let data: any = [];
      data.push({
        advancedSearchId: searchId,
        pageno: pageno,
        itemsperpage: this.itemsPerPageText,
        userid: this.userid,
        sorting: sorting,
        archiveyear: this.archiveyear

      });
      if (this.totalformdetailcount != 0) {
        this.getvaluesConditionObj = data[0];
        this.isadvancesearch = true;

        this.formdashboardservice.getformadvancedsearchdetails(data[0]).subscribe(async res => {
          if (res != undefined && res.length != 0) {
            let _searchDocumentList: any = [];
            _searchDocumentList = JSON.parse(res.body[0].formdetails);
            this.selectedFormConfigId = _searchDocumentList[0].formconfigid;
            this.formConfigName = this.selectedNodeText;
            if ((_searchDocumentList != undefined) && (_searchDocumentList.length != 0)) {
              this.headers = [];
              //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
              //let html = formConfigField.filter(x => x.displaystatus == 1);
              //html.forEach(element => {
              //  element['label'] = element.name;
              //});
              var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
              let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
              var _headers = Object.keys(_searchDocumentList[0]);
              this.headers = [];
              _headers.forEach(i => {
                //          if ((i.toString() != 'documentid') && (i.toString() != "createdby") && (i.toString() != "createdon")
                //            && (i.toString() != "Created By") && (i.toString() != "Created On") && (i.toString() != 'read')
                //            && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                //            && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                //          ) {
                //            var f = htmldata.filter(e => e.label == i)[0].type;
                //            if (f.length != 0) {
                //              this.headers.push({
                //                columnname: i,
                //                columntype: f,
                //                searchname: ''
                //              });
                //            }
                //else {
                //            this.headers.push({
                //              columnname: i,
                //              columntype: 'text',
                //              searchname: ''
                //            });
                //          }
                //          }
                var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"));
                if ((f.length != 0) && (this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
                  if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                    && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                    && (i.toString() != "groupname")
                    && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                    && (i.toString() != "eutitletooltip")
                  ) {
                    this.headers.push({
                      columnname: i,
                      columntype: f[0].type,
                      searchname: ''
                    });
                  }
                  else {
                    this.headers.push({
                      columnname: i,
                      columntype: 'text',
                      searchname: ''
                    });
                  }
                }
                else {
                  if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview') {
                    if (i.toString() == 'Created Date') {
                      this.headers.push({
                        columnname: i,
                        columntype: 'date',
                        searchname: ''
                      });
                    }
                    else if (i.toString() == 'File Name') {
                      this.headers.push({
                        columnname: i,
                        columntype: 'file',
                        searchname: ''
                      });
                    }
                    else {
                      this.headers.push({
                        columnname: i,
                        columntype: 'text',
                        searchname: ''
                      });
                    }
                  }
                }


              });
              this.rowsData = [];
              this.columns = [];
              this.customSearchDocumentList = [];
              if (_searchDocumentList.length != 0) {
                // this.customSearchDocumentList = _searchDocumentList;
                this.rowsData = _searchDocumentList;
                this.rowsData.forEach(element => {
                  if (element.read) {
                    element['isReadCheck'] = null;
                  } else {
                    element['isReadCheck'] = false;
                  }
                });
                this.groupSearch = false;
                this.SpinnerService.hide();
              }
            }
          }
          else {
            this.SpinnerService.hide();
            this.customSearchDocumentList = [];
            this.customSearchHeaders = [];
            this.rowsData = [];
            this.headers = [];
            this.groupSearch = false;
          }

        },
          err => {
            this.toastr.error('Not able to get searched data');
            this.SpinnerService.hide();
            this.customSearchDocumentList = [];
            this.customSearchHeaders = [];
            this.headers = [];
            this.rowsData = [];
            this.groupSearch = false;
          });
      }
      else {
        this.headers = [];
        this.rowsData = [];
        this.SpinnerService.hide();
        this.groupSearch = false;
      }


      this.SpinnerService.hide();
      //  this.loadFilter();
    });
  }


  previewFilter(pagenumber) {
    this.SpinnerService.show();
    this.groupByList = [];
    this.totalformdetailcount = 0;
    this.rowsData = []; var fieldsList = [];
    var daterange = ''; var author = ''; var fieldsname = ''; var fieldscondition = ''; var _groupAuthorText = {}; var _groupFieldsText = {}; var groupFieldsCondition = {}; var _groupFieldsCondition = {};
    let _groupPreviewFilter: any = [];
    this.previewfilterflag = true;
    if (this.selectedStartDate != undefined && this.selectedStartDate != null && this.selectedStartDate.length != 0)
      daterange = this.datePipe.transform(this.selectedStartDate[0], "MM/dd/yyyy") + '-' + this.datePipe.transform(this.selectedStartDate[1], "MM/dd/yyyy");
    if (this.selectedFormFields != undefined && this.selectedFormFields != null && this.selectedFormFields.length != 0) {
      //  _groupFieldsText['fieldsname'] = this.selectedFormFields.map(e => { return e.formfieldsid });
      fieldsname = this.selectedFormFields.map(e => { return e.formfieldsid });
    }
    if (this.fieldgroupListadded != undefined && this.fieldgroupListadded != null && this.fieldgroupListadded.length != 0) {
      let fieldCondn = this.fieldgroupListadded.filter(e => e.removed != true && e.fieldsname != 'Select Field Name');
      fieldsList = JSON.parse(JSON.stringify(fieldCondn));
      fieldsList.forEach((i, index) => {
        if (i.fieldstype != 'date') {
          if (i.condition == 1)
            i.condition = 'Equals';
          else
            i.condition = 'Contains';
        }
        if (i.fieldstype == 'date') {
          if (i.condition == 1)
            i.condition = 'Equals';
          else
            i.condition = 'Between';
        }

      });
      fieldsList.map(function (obj) { delete obj.fieldsid; delete obj.fieldeditmode; });
      if (daterange != '') {
        fieldsList.push({ fieldsname: 'createdon', condition: 'Between', fieldstype: 'date', label: 'createdon', value: daterange });
      }
      if (this._selectedItems != undefined && this._selectedItems != null && this._selectedItems.length != 0) {
        _groupAuthorText['author'] = this._selectedItems.map(e => { return e.authorId });
        fieldsList.push({ fieldsname: 'createdby', condition: 'contains', fieldstype: 'text', label: 'createdby', value: JSON.stringify(_groupAuthorText['author']) });
      }
      //  groupFieldsCondition['FieldsCondition'] = fieldsList;
      fieldscondition = JSON.stringify(fieldsList);
    }
    else {
      if (daterange != '') {
        fieldsList.push({ fieldsname: 'createdon', condition: 'Between', fieldstype: 'date', label: 'createdon', value: daterange });
      }
      if (this._selectedItems != undefined && this._selectedItems != null && this._selectedItems.length != 0) {
        _groupAuthorText['author'] = this._selectedItems.map(e => { return e.authorId });
        fieldsList.push({ fieldsname: 'createdby', condition: 'contains', fieldstype: 'text', label: 'createdby', value: JSON.stringify(_groupAuthorText['author']) });
      }
      fieldscondition = JSON.stringify(fieldsList);
    }
    _groupPreviewFilter.push({
      fieldsname: fieldsname,
      fieldscondition: fieldsList,
      formconfigid: this.selectedFormConfigId
    });

    let formdata: any = [];
    formdata.push({
      advancedSearchId: 0,
      pageno: this.p,
      itemsperpage: this.itemsPerPageText,
      userid: this.userid,
      fieldscondition: JSON.stringify(_groupPreviewFilter[0]),
      archiveyear: this.archiveyear
    });
    this.countConditionObj = formdata[0];
    
    this.formdashboardservice.getformadvancedsearchdetailscount(formdata[0]).subscribe(res => {
      if (res != undefined && res != null) {
        this.totalformdetailcount = JSON.parse(res.body[0].formdetails)[0].count;
      }
      let data: any = [];
      data.push({
        advancedSearchId: 0,
        pageno: this.p,
        userid: this.userid,
        itemsperpage: this.itemsPerPageText,
        fieldscondition: JSON.stringify(_groupPreviewFilter[0]),
        sorting: this.sorting,
        archiveyear: this.archiveyear
      });
      if (this.totalformdetailcount != 0) {
        this.getvaluesConditionObj = data[0];
        this.isadvancesearch = true;
        this.formdashboardservice.getformadvancedsearchdetails(data[0]).subscribe(async res => {
          if (res != undefined && res.length != 0 && res.body[0].formdetails != null) {
            let _searchDocumentList: any = [];
            _searchDocumentList = JSON.parse(res.body[0].formdetails);
            this.selectedFormConfigId = _searchDocumentList[0].formconfigid;
            this.formConfigName = this.selectedNodeText;
            if ((_searchDocumentList != undefined) && (_searchDocumentList.length != 0)) {
              this.headers = [];
              //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
              //let html = formConfigField.filter(x => x.displaystatus == 1);
              //html.forEach(element => {
              //  element['label'] = element.name;
              //});
              var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
              let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
              var _headers = Object.keys(_searchDocumentList[0]);
              _headers.forEach(i => {
                //if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                //  && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                //  && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                //) {
                //  var f = htmldata.filter(e => e.label == i)[0].type;
                //  if (f.length != 0) {
                //    this.headers.push({
                //      columnname: i,
                //      columntype: f,
                //      searchname: ''
                //    });
                //  }
                //  else {
                //    this.headers.push({
                //      columnname: i,
                //      columntype: 'text',
                //      searchname: ''
                //    });
                //  }
                //}
                var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"));
                if ((f.length != 0) && (this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
                  if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                    && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                    && (i.toString() != "groupname")
                    && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                  &&  (i.toString() != "eutitletooltip")
                  ) {
                    this.headers.push({
                      columnname: i,
                      columntype: f[0].type,
                      searchname: ''
                    });
                  }
                  else {
                    this.headers.push({
                      columnname: i,
                      columntype: 'text',
                      searchname: ''
                    });
                  }
                }
                else {
                  if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview') {
                    if (i.toString() == 'Created Date') {
                      this.headers.push({
                        columnname: i,
                        columntype: 'date',
                        searchname: ''
                      });
                    }
                    else if (i.toString() == 'File Name') {
                      this.headers.push({
                        columnname: i,
                        columntype: 'file',
                        searchname: ''
                      });
                    }
                    else {
                      this.headers.push({
                        columnname: i,
                        columntype: 'text',
                        searchname: ''
                      });
                    }
                  }
                }
              });
              this.rowsData = [];
              this.columns = [];
              if (_searchDocumentList.length != 0) {
                this.rowsData = _searchDocumentList; this.rowsData.forEach(element => {
                  if (element.read) {
                    element['isReadCheck'] = null;
                  } else {
                    element['isReadCheck'] = false;
                  }
                });

                this.groupSearch = false;
                this.SpinnerService.hide();
              }
            }
          }
          else {
            // this.toastr.error('No preview data found');
            this.rowsData = [];
            this.headers = [];
            this.groupSearch = false;
            this.SpinnerService.hide();
          }


        },
          err => {
            this.toastr.error('Not able to get preview data');
            this.SpinnerService.hide();
            this.rowsData = [];
            this.headers = [];
          });
      }
      else {
        this.SpinnerService.hide();
        this.rowsData = [];
        this.headers = [];
      }
    });
    this.fieldgroupListadded.forEach((i, ind) => {
      this.fieldgroupListadded[ind]["fieldeditmode"] = true;
    });
  }

  //clearpreviewFilter
  clearpreviewFilter() {
    this.previewFilterList = []; this.previewSearchHeaders = []; this.previewcolumns = [];
  }




  //export to csv
  exportAsCSV(rowList, headersList) {
    var today = new Date();
    var date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    var time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + ' ' + time;
    // console.log(this.formConfigName);
    // console.log(dateTime);
    const columns: TableColumn[] = headersList;
    const headers =
      columns
        .map((column: TableColumn) => column.name)
        .filter((e) => e);  // remove column without name (i.e. falsy value)

    const rows: any[] = rowList.map((row) => {
      let r = {};
      columns.forEach((column) => {
        if (!column.name) { return; }   // ignore column without name
        if (column.prop) {
          let prop = column.prop;
          r[prop] = (typeof row[prop] === 'boolean') ? (row[prop]) ? 'Yes'
            : 'No'
            : row[prop];
        } else {
          // special cases handled here
        }
      })
      return r;
    });


    const optionsExport = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      headers: headers,
      showTitle: false,
      title: 'Report',
      useBom: true,
    };
    return new Angular5Csv(rows, this.formConfigName + '-' + dateTime, optionsExport);
  }

  //export to excel
  ExportTOExcel(exportmode) {
    //normal formdashbaord data
    let filedownloadUrl: string = environment.appUrl;
    //if (exportmode == 'formdashbaord') {
    //  var newWindow = window.open(filedownloadUrl + 'filedownload?formconfigid=' + this.selectedFormConfigId + '&mode=' + '"formdashbaord"&formconfigname="' + this.formConfigName + '"');
    //}
    //if (exportmode == 'advancedsearch') {
    //  var newWindow = window.open(filedownloadUrl + 'filedownload?advancedSearchId=' + this.advancedSearchId + '&mode=' + '"advancedsearch"&formconfigname="' + this.formConfigName + '"&userid=' + this.userid);
    //}
    if (this.advancedSearchId == 0) {
      var newWindow = window.open(filedownloadUrl + 'filedownload?formconfigid=' + this.selectedFormConfigId + '&mode=' + 'formdashbaord&formconfigname="' + this.formConfigName + '"');
    }
    if (this.advancedSearchId > 0) {
      var newWindow = window.open(filedownloadUrl + 'filedownload?advancedSearchId=' + this.advancedSearchId + '&mode=' + 'advancedsearch&formconfigname="' + this.formConfigName + '"&userid=' + this.userid);
    }
  }


  clearall() {
    this.fieldgroupListadded = []; this.selectedFormFields = []; this.selectedStartDate = []; this.userSelectedFilter = ''; this.filternameTxt = ''; this._selectedItems = [];
    this.customSearchEnable = false;
    this.advancedSearchEditMode = false;
    this.isCustomSearch = false;
    this.groupRowsBy = 'All';
    this.Loadformdetails(1);
    $('#showalluser')[0].checked = false;
  }

  clearformfields() {
    this.userSelectedFilter = ''; this.selectedFormFields = [];
  }

  clearconditions() {
    this.selectedStartDate = []; this._selectedItems = []; this.userSelectedFilter = ''; this.fieldgroupListadded = []; this.addFormFields = true;
    this.customSearchEnable = false;
  }

  showconditiontab() {
    this.tabs.select('conditiontab');
  }

  showsavetab() {
    if (this.fieldgroupListadded.filter(e => e.removed != true && (e.fieldsname == 'Select Field Name' || e.fieldsname != 'Select Field Name') && (e.value == undefined || e.value == '')).length != 0) {
      this.toastr.error("Fields need to select and values cannot be empty");
      return;
    } else {
      this.selectedValue();
      this.tabs.select('savetab');
    }
  }

  expandall(totalformdetailcount) {
    this.SpinnerService.show();

    if (this.entry.length > 0) {
      this.entry.forEach(container => {
        container.viewContainerRef.clear();
      });
    }

    this.groupExpansionDefault = true;
    this.SpinnerService.show();
    var i = 0;
    var j = 0;
    let groupbyLoad = [];
    const myFactory = this.resolver.resolveComponentFactory(FormdashboardgrouptableComponent);
    this.rowsData.forEach(data => {
      const myRef = this.entry.toArray()[i].viewContainerRef.createComponent(myFactory);
      this.entry.toArray()[i].viewContainerRef.element.nativeElement.id = i;
      myRef.instance['formconfigid'] = this.selectedFormConfigId;
      myRef.instance['selectedvalue'] = data.groupname;
      myRef.instance["page"] = this.p;
      myRef.instance["pagenumber"] = 1;
      myRef.instance["databaseid"] = this.databaseId;
      myRef.instance["databasename"] = this.databaseName;
      myRef.instance["delete"] = this.delete;
      myRef.instance["formconfigname"] = this.formConfigName;
      myRef.instance["searchby"] = this.groupRowsBy;
      myRef.instance["archiveyear"] = this.archiveyear;
      myRef.instance["groupleveldata"] = this.groupleveldataname;
      myRef.changeDetectorRef.detectChanges();
      myRef.instance.groupbyloading.subscribe(
        data => {
          groupbyLoad.push(data);
          if (groupbyLoad.length == this.rowsData.length) {
            this.SpinnerService.hide();
          }

          j = j + 1;

        }, error => { j = j + 1; });

      i = i + 1;
    });

    // if (j >0)
    this.SpinnerService.hide();

    for (var i = 0; totalformdetailcount > i; i++) {
      $('.divgroupby' + i).show();
      $('#iconup' + i).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
    }


    //this.collapsetext = 'Collapse All';


  }

  collapaseall(totalformdetailcount) {
    this.groupExpansionDefault = false;
    //this.collapsetext = 'Expand All';

    for (var i = 0; totalformdetailcount > i; i++) {
      $('.divgroupby' + i).hide();
      $('#iconup' + i).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
    }



  }

  onKeydown(event) {
    if (event.key === "Enter") {
      //   console.log(this.itemsPerPageText);
    }
  }

  changeitemsperpage(eve) {
    this.itemsPerPageText = eve;
    this._itemsPerPage = eve;
    this.markallcheckbox = false;
    if (this.isitemperpagechanged) {
      this.addpagepreference(eve);
    }

    if (this.rowsData.length != 0 && this.customSearchDocumentList.length == 0) {
      this.getPage(this.p);

    }
    if (this.customSearchDocumentList.length != 0 && this.rowsData.length == 0) {
      this.getCustomPage(this.p);

    }

  }

  printList(rowList) {

    window.print();
  }

  savestartover() {
    this.fieldgroupListadded = []; this.selectedFormFields = []; this.selectedStartDate = []; this.userSelectedFilter = ''; this.filternameTxt = ''; this._selectedItems = [];
    this.addFormFields = false;
    this.customSearchEnable = false;
    $('#showalluser')[0].checked = false;
    this.rowsData = [];
    this.rowsData = this.initialRowDataList;
    this.headers = Object.keys(this.rowsData[0]);
    this.Loadformdetails(1);
    if (this.headers.length != 0) {
      this.columns = [];
      this.headers.forEach(i => {
        this.columns.push({
          name: i, prop: i
        });
      })
    }
  }


  openModalLoadFilter(template: TemplateRef<any>) {
    this.allAdvancedSearchList = [];
    this.formdashboardservice.getAllAdvancedSearch().subscribe(res => {
      if (res != undefined) {
        //this.allAdvancedSearchList = res.filter(e => e.createdby == localStorage.getItem('userid') && e.formconfigid == this.selectedFormConfigId && e.dbid == this.databaseId);
        this.allAdvancedSearchList = res.filter(e => e.createdby == this.localService.getJsonValue('userid') && e.formconfigid == this.selectedFormConfigId && e.dbid == this.databaseId);
      }
      if (this.allAdvancedSearchList.length > 0) {
        this.modalRef = this.modalService.show(template, this.config);
        const aa = document.getElementsByClassName('modal-content');
        aa[0].classList.remove("modal-content");
      }
      else {
        this.toastr.error('No Search Filters created to display');
        return;
      }
    });
  }

  removeFilter(advancedSearchid, activestatus) {
    let formAdvancedSearch = new FormDashboard;
    formAdvancedSearch.advancedsearchid = advancedSearchid;
    formAdvancedSearch.active = activestatus;
    var message = '';
    if (activestatus == 0)
      message = 'deactivate';
    else
      message = 'activate';
    let showpopup = this.dialogService.addDialog(CommondialogComponent,
      {
        title: 'Please Confirm',
        message: 'Are you sure you want to ' + message + ' this record ?',
        hclass: 'modelsuccess',
        oktext: 'Yes',
        canceltext: 'No',
        okshow: true,
        cancelshow: true
      }).subscribe((isConfirmed) => {
        if (isConfirmed) {
          this.formdashboardservice.removeAdvancedSearch(formAdvancedSearch).subscribe(res => {
            if (res.body != 0) {
              this.toastr.success("Filter data " + message + "d successfully");
              this.loadFilter();
              this.Loadtree();
            }
            else {
              this.toastr.error("Error while doing the operation");
            }
          });
        }

      });
  }

  showforall(eve) {
    if (eve.target.checked)
      this.showStatus = 1;
    else
      this.showStatus = 0;
  }

  showhidechevron(id) {
    
    $('.divgroupby' + id).toggle(function () {
      //  alert('');
    });
    $('.divgroupby' + id, $(this).parent()).toggle();
    if ($('#iconup' + id).hasClass('glyphicon-chevron-up') == true) {
      $('#iconup' + id).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
    }
    else {
      $('#iconup' + id).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
    }
  }
  toggle(groupname, id) {
    // $('.divgroupby' + id, $(this).parent()).hide();

    let idValue = this.selectedNodeText == 'By Allocation and Court' ? '#iconup_' : '#iconup';

    if (this.groupByFromRender == true && groupname == this.searchData) {
      // tslint:disable-next-line: max-line-length
      $(idValue + id).hasClass('glyphicon-chevron-up') == true ? $(idValue + id).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down') : '';
      this.searchData = '';
    }
    this.selectedgroupdata.push({
      groupnameselected: groupname
    });


    if (this.selectedNodeText == 'By Allocation and Court') {
      groupname = this.groupleveldataname + ":" + groupname ;
    }

    if ($(idValue + id).hasClass('glyphicon-chevron-up') == true) {
      $('.divgroupby' + id).show();
      $(idValue + id).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
      this.entry.toArray()[id].viewContainerRef.clear();
      this.groupname = groupname;
      if (this.entry.toArray()[id].viewContainerRef.length <= 0) {
        this.SpinnerService.show();
        const myFactory = this.resolver.resolveComponentFactory(FormdashboardgrouptableComponent);
        // if (this.entry.toArray()[index].viewContainerRef.length <= 0) {
        var i = 0
        // this.entry.forEach(container => {
        //let containerid = this.entry.toArray()[id].viewContainerRef.element.nativeElement.id
        //  if (containerid == id) {
        this.searchDataValue = groupname;

        const myRef = this.entry.toArray()[id].viewContainerRef.createComponent(myFactory);
        this.entry.toArray()[id].viewContainerRef.element.nativeElement.id = id;
        myRef.instance['formconfigid'] = this.selectedFormConfigId;

        myRef.instance['selectedvalue'] = groupname;
        myRef.instance["page"] = this.p;
        myRef.instance["pagenumber"] = 1;
        myRef.instance["itemsPerPage"] = this._itemsPerPage;
        myRef.instance["databaseid"] = this.databaseId;
        myRef.instance["databasename"] = this.databaseName;
        myRef.instance["delete"] = this.delete;
        myRef.instance["formconfigname"] = this.formConfigName;
        myRef.instance["searchby"] = this.groupRowsBy;
        myRef.instance["selectedNodeTextValue"] = this.selectedNodeText;
        myRef.instance["archiveyear"] = this.archiveyear;
        myRef.instance["groupleveldata"] = this.groupleveldataname;
        myRef.changeDetectorRef.detectChanges();
        myRef.instance.groupbyloading.subscribe(
          data => {
            this.SpinnerService.hide();

          }, error => { this.SpinnerService.hide(); });

      }
    }
    else {
      $('.divgroupby' + id).hide();
      $(idValue + id).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
    }
    // $('.divgroupby' + id).toggle();

    //$('#iconup'+id)
    //$('.divgroupby').hide();
    //$("#iconup").prop('display', 'e');
    //if (this.togglegroupby == true) {
    //  this.togglegroupby = false;
    //}
    //else {
    //  this.togglegroupby = true;
    //}
    
    // $('.divgroupby' + id, $(this).parent()).toggle();


    // }
    //});

    // $('.showinfo').click(function () {


    // });


  }




  addNewsletter() {
    this.SpinnerService.show();
    this.mailConfigSer.Getformdetailsfornewsletter(this.databaseId.toString(), this.databaseName, this.formconfigidnewsletter.toString()).subscribe(
      (res) => {
        if (res != undefined && res.message != '') {
          var config: ModalOptions = {
            backdrop: 'static',
            keyboard: false,
            animated: true,
            ignoreBackdropClick: true,
            class: 'modal-lg',
            initialState: {
              formconfigid: this.formconfigidnewsletter,
              dbid: this.databaseId,
              dbname: this.databaseName
            }
          }
          this.bsModalRef = this.modalService.show(NewsletterComponent, config);
          this.bsModalRef.content.closeBtnName = 'Close';
          this.SpinnerService.hide();
        }
        else {
          this.toastr.error('No Newsletter information to display');
          this.SpinnerService.hide();
          return;
        }
      }
      , err => { this.SpinnerService.hide(); }
    );

  }


  Loadtree() {
    
    var childrenFirstLevel = []; var childrenSecondLevel = []; var number = 0; var final = [];var childrenThirdLevel = [];
    var _childrenSecondLevel = [];
    let _nodelist: any = []; let nodelist123: any;
    this.formdashboardservice.getformsearchdetailsfieldnametreeview(this.userid, this.archiveformconfigid, this.archiveyear).subscribe(
      (res) => {
        
        if (res != undefined) {
          var data = [];
          if (res != undefined && res != null && res.length != 0) {
            this.treeviewlist = JSON.parse(res.treevalue);
            this.treeviewlist = this.treeviewlist.filter(e => e.dbid == this.databaseId);
            console.log(this.treeviewlist);
            var allData = this.treeviewlist;
            if (allData != undefined) {
              allData.forEach(i => {
                if (i.children.length != 0 && i.children != undefined && i.children != null) {
                  var childrenData = [];
                  childrenFirstLevel = [];
                  childrenData = i.children;
                  if (childrenData.length != 0) {
                    childrenData.forEach(n => {
                      childrenSecondLevel = [];                      
                      if (n.value == 'customsearch') {
                        childrenSecondLevel = JSON.parse(n.children);
                        if (childrenSecondLevel != undefined && childrenSecondLevel != null && childrenSecondLevel.length != 0) {
                          var customSearchExists = [];var childrenExists=[];  var _childrenData = [];
                          customSearchExists = childrenFirstLevel.filter(e => e.text == 'Custom Search');  
                          _childrenSecondLevel=[]; 
                          childrenSecondLevel.forEach((m,ind)=> {
                         _childrenData=JSON.parse(m.children);
                          if (_childrenData != null && _childrenData !=undefined && _childrenData.length != 0) {
                          childrenExists=_childrenData; 
                          childrenThirdLevel=[];
                          if(childrenExists.length == 0){
                            _childrenSecondLevel.push({ value: m.value, text: m.text, children: null }); 
                          } else{                           
                            _childrenData.forEach(g => {
                            childrenThirdLevel.push({ value: g.value, text: g.text, children: null });                                                    
                          });
                          _childrenSecondLevel.push({ value: m.value, text: m.text, children: childrenThirdLevel });                       
                          }
                           }     else{
                            _childrenSecondLevel.push({ value: m.value, text: m.text, children: null });  
                           }                    

                          });
                          childrenFirstLevel.push({ value: n.value, text: 'Custom Search', children: _childrenSecondLevel});

                        }
                      
                      }
                      else {
                        childrenFirstLevel.push({ value: n.value, text: n.text, children: null });
                      }
                    });
                  }
                }
                for (var j = 0; j < childrenFirstLevel.length; j++) {
                  if (childrenFirstLevel[j].children != undefined && childrenFirstLevel[j].children != null) {
                    childrenFirstLevel[j].children.sort(function (a, b) { return a.text.toLowerCase().localeCompare(b.text.toLowerCase()); });
                  }
                }
                childrenFirstLevel.sort(function (a, b) {
                  return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
                });
                _nodelist = new TreeviewItem({
                  value: i.formconfigid,
                  text: i.formconfigname,
                  collapsed: false,
                  children: childrenFirstLevel
                });
                final.push(_nodelist);
              });

              this.itemsList = final;
              this.itemsList.forEach(item => {
                item.checked = false;
                if (item["internalChildren"] != undefined && item["internalChildren"] != null && item["internalChildren"].length != 0) {
                  item["internalChildren"].forEach(item => {
                    item.checked = false;
                    if (item["internalChildren"] != undefined && item["internalChildren"] != null && item["internalChildren"].length != 0) {
                      item["internalChildren"].forEach(i => {
                        i.checked = false;
                      });
                    }
                  });
                }
              });

            }
          }
        }

      },
      error => {
       
        this.toastr.error(error.error);
      });
  }


 /* Loadtree() {
    var childrenFirstLevel = []; var childrenSecondLevel = []; var number = 0; var final = [];
    let _nodelist: any = []; let nodelist123: any;
    this.formdashboardservice.getformsearchdetailsfieldnametreeview(this.userid, this.archiveformconfigid, this.archiveyear).subscribe(
      (res) => {
        if (res != undefined) {
          var data = [];
          if (res != undefined && res != null && res.length != 0) {
            this.treeviewlist = JSON.parse(res.treevalue);

            this.treeviewlist = this.treeviewlist.filter(e => e.dbid == this.databaseId);
            //console.log(this.treeviewlist);
            var allData = this.treeviewlist;
            if (allData != undefined) {
              allData.forEach(i => {
                if (i.children.length != 0 && i.children != undefined && i.children != null) {
                  var childrenData = [];
                  childrenFirstLevel = [];
                  childrenData = i.children;
                  if (childrenData.length != 0) {
                    childrenData.forEach(n => {
                      childrenSecondLevel = [];
                      if (n.value == 'customsearch') {
                        childrenSecondLevel = JSON.parse(n.children);
                        if (childrenSecondLevel != undefined && childrenSecondLevel != null && childrenSecondLevel.length != 0) {
                          var customSearchExists = [];
                          customSearchExists = childrenFirstLevel.filter(e => e.text == 'Custom Search');
                          if (customSearchExists.length != 0) {
                            childrenFirstLevel.forEach((i, ind) => {
                              if (i.text == 'Custom Search') {
                                childrenSecondLevel.forEach(m => {
                                  i.children.push(
                                    {
                                      text: m.text,
                                      value: m.value
                                    });
                                });

                              }
                            });

                          }
                          else {
                            childrenFirstLevel.push({ value: n.value, text: 'Custom Search', children: childrenSecondLevel });
                          }
                        }

                      }
                      else {
                        childrenFirstLevel.push({ value: n.value, text: n.text, children: null });
                      }
                    });
                  }
                }
                for (var j = 0; j < childrenFirstLevel.length; j++) {
                  if (childrenFirstLevel[j].children != undefined && childrenFirstLevel[j].children != null) {
                    childrenFirstLevel[j].children.sort(function (a, b) { return a.text.toLowerCase().localeCompare(b.text.toLowerCase()); });
                  }
                }
                childrenFirstLevel.sort(function (a, b) {
                  return a.text.toLowerCase().localeCompare(b.text.toLowerCase());
                });
                _nodelist = new TreeviewItem({
                  value: i.formconfigid,
                  text: i.formconfigname,
                  collapsed: false,
                  children: childrenFirstLevel
                });
                final.push(_nodelist);
              });

              this.itemsList = final;
              this.itemsList.forEach(item => {
                item.checked = false;
                if (item["internalChildren"] != undefined && item["internalChildren"] != null && item["internalChildren"].length != 0) {
                  item["internalChildren"].forEach(item => {
                    item.checked = false;
                    if (item["internalChildren"] != undefined && item["internalChildren"] != null && item["internalChildren"].length != 0) {
                      item["internalChildren"].forEach(i => {
                        i.checked = false;
                      });
                    }
                  });
                }
              });

            }
          }
        }

      },
      error => {
        this.toastr.error(error.error);
      });
  }*/


  updateMyDate1(eve, fieldname, i) {
    this.selectedfieldDate[i] = eve;
    this.fieldgroupListadded.forEach((i, ind) => {
      if (i.fieldsname == fieldname && i.fieldstype == 'date')
        i.value = this.datePipe.transform(this.selectedfieldDate[ind][0], "MM/dd/yyyy") + '-' + this.datePipe.transform(this.selectedfieldDate[ind][1], "MM/dd/yyyy")


    })

  }

  // addDocument() {
  //   //this._router.navigate(['/home/formrender', { 'db': this.databaseId }]);
  //this._router.navigate(['/home/formrender'], { queryParams: { 'db': this.databaseId, 'mode': 'add' } });
  // }

  addDocument() {
    //this._router.navigate(['/home/formrender', { 'db': this.databaseId }]);
    // let database = this.databaseId + '*' + this.databaseName;

    //  let queryParams = {};
    // queryParams['formDB'] = database;
    //queryParams['db'] = this.databaseId;
    //queryParams['mode'] = 'add';
    //// this.by == 'teamallocation' ? queryParams['data'] = item["ACRN Doc ID"] : queryParams['data'] = item["documentid"];
    // queryParams['data'] = item["documentid"];
    //queryParams['formConfigId'] = this.selectedFormConfigId;
    //queryParams['page'] = this.p;
    //queryParams['selectedgroup'] = this.by;
    //queryParams['searchdata'] = this.searchDataValue;
    //queryParams['filterTable'] = this.filterPatchData.length > 0;
    //// this.filterPatchData.length > 0 ? queryParams['filterValue'] = JSON.stringify(this.filterPatchData) : '';
    //queryParams['isCustomSearch'] = this.isCustomSearch;
    //queryParams['itemsPerPage'] = this._itemsPerPage;
    //this.isCustomSearch ? queryParams['customSearchData'] = this.customSearchData : '';


    if ((this.searchDataValue != null && this.searchDataValue != undefined && this.searchDataValue != '')) {
      this.entry.forEach(container => {
        let containerid = container.viewContainerRef.element.nativeElement.id;
        //  if (containerid == selproduct.productid) {
        if (container.viewContainerRef !== undefined) {
          if (container.viewContainerRef['_embeddedViews'].length != 0) {
            for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
              if (container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.selectedvalue == this.searchDataValue) {
                this.subPage = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.p;
                this.headers = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.headers;
                this._columnsearchgroup = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance._columnsearchgroup;
                this.isSort = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.isSort;
                this.colkey = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.colkey;
                this.sortDirection = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.sortDirection;
                this.sortingcondition = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.sortingcondition;
              }
            }
          }
          //   }

        }
      });
    }
    else {
      this.searchDataValue = this.searchData;
    }

    let database = this.databaseId + '*' + this.databaseName;
    let queryParams = {};
    queryParams['db'] = this.enc.encryptUsingAES256(this.databaseId.toString());  //this.databaseId;
    queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.selectedFormConfigId.toString());//this.selectedFormConfigId;
    queryParams['mode'] = this.enc.encryptUsingAES256('add');//'add';





    const navigationExtras: NavigationExtras = {
      queryParams,

      state: {
        db: this.databaseId,
        formDB: database,
        //data: this.by == 'teamallocation' || this.by == 'teamallocationreview' ? item["ACRN Doc ID"] : item["documentid"],
        formConfigId: this.selectedFormConfigId,
        mode: 'add',
        page: this.p,
        selectedgroup: this.by,
        searchdata: this.searchDataValue,
        filterTable: this.filterPatchData.length > 0,
        filterValue: this.filterPatchData.length > 0 ? JSON.stringify(this.filterPatchData) : '',
        isCustomSearch: this.isCustomSearch,
        itemsPerPage: this._itemsPerPage,
        customSearchData: this.isCustomSearch ? this.customSearchData : '',
        selectedNodeText: this.selectedNodeText,
        subPage: this.subPage,
        columnsearchname: JSON.stringify(this.headers),
        columnsearchgroup: JSON.stringify(this._columnsearchgroup),
        isSort: this.isSort,
        sortingconditionValue: this.colkey,
        sortDirectionValue: this.sortDirection,
        customSearchSortConditionValue: this.sortingcondition,
        selectedNodeValue: this.selectedNodeValue,
        archiveyear: this.archiveyear
      }
    };

    this._router.navigate(['/home/formrender'], navigationExtras);




  }

  async sorting(col, val) {
     this.isSort = true;
    if (val == 0)
      this.sortingcondition == '';
    //if (this.colkey != col)
    //  this.sortingcondition == '';
    if (this.colkey != col) {
      this.sortingcondition == '';
      this.sortDirection = 'desc';
    }
    let _sortedList: any = [];
    var sortingCondition = '';
    if (this.sortingcondition == '' || this.pageevent != true)
      this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
    if (this.formConfigList != undefined && this.formConfigList != null && this.formConfigList.length != 0) {
      //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
      //let html = formConfigField.filter(x => x.displaystatus == 1);
      //html.forEach(element => {
      //  element['label'] = element.name;
      //});
      var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
      let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
      if (htmldata.length != 0) {
        var u = htmldata.filter(e => e.label == col && e.type != 'select' && e.type != 'checkbox-group' && e.type != 'radio-group')
        this.SpinnerService.show();
        this.colkey = col;
        //var s = htmldata.filter(e => e.label == col)[0].formcontrolname.toLowerCase()

        //code to handle team allocation
        var l = htmldata.filter(e => e.label == col);
       
        if (l == null || l == undefined || l == '') {
          s = col;
        }
        else {
          var s = htmldata.filter(e => e.label == col)[0].formcontrolname.toLowerCase();
        }


        if (s != null && s != undefined && s != '') {
         
          if (this.by == "teamallocation" || this.by == "teamallocationreview" || this.by == "teamallocationnotreview") {
            sortingCondition = col + ':' + this.sortDirection;            
             this.sortingcondition = sortingCondition;
          } else
          {
            sortingCondition = s + ' ' + this.sortDirection;
            this.sortingcondition = sortingCondition;
          }
          if (this._columnsearchgroup == '') {

            if (this.advancedSearchId == 0) {
              if (this.previewfilterflag == false) {
                let input: any = [];
                //code to handle team allocation
                var searchcondition = 'All';
                if (this.by == "teamallocation" || this.by == "teamallocationreview" || this.by == "teamallocationnotreview") {
                  searchcondition = this.by;
                  sortingCondition = col + ':' + this.sortDirection;
                 // sortingCondition = s + ' ' + this.sortDirection;
                  this.sortingcondition = sortingCondition;
                }

                input.push({
                  'formconfigid': this.selectedFormConfigId,
                  'pageno': this.p, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition, 'userid': this.userid, 'sorting': null, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
                });
                this.countConditionObj = input[0];
                this.formdashboardservice.getAllFormDocumentDetailscount(input[0]).subscribe(
                  (res) => {
                    if (res.body.count > 0) {
                      this.totalformdetailcount = res.body.count;
                      if (this.totalformdetailcount != 0) {
                        //  this.totalformdetailcount = res.body.count;
                        let obj: any = [];
                        obj.push({
                          'formconfigid': this.selectedFormConfigId, 'pageno': this.p, 'itemsperpage': this.itemsPerPageText, 'searchcondition': searchcondition, 'userid': this.userid, 'sorting': sortingCondition, 'groupleveldata': this.groupleveldata, 'archiveyear': this.archiveyear
                        });
                        this.getvaluesConditionObj = obj[0];
                        this.isadvancesearch = false;
                        this.formdashboardservice.getAllFormDocumentDetailsSorting(obj[0]).subscribe(async res => {
                          if (res != undefined && res != null && res.length != 0) {
                            this.rowsData = [];
                            this.headers = [];
                            _sortedList = JSON.parse(res.body[0].j);
                            if (_sortedList != undefined && _sortedList != null && _sortedList.length != 0) {
                              _sortedList.map(function (obj) { delete obj.createdby; delete obj.createdon; delete obj.formconfigid });
                              //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
                              //let html = formConfigField.filter(x => x.displaystatus == 1);
                              //html.forEach(element => {
                              //  element['label'] = element.name;
                              //});
                              var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
                              let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
                              var _headers = Object.keys(_sortedList[0]);
                              _headers.forEach(i => {
                                //if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                                //  && (i.toString() != 'read')
                                //  && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                                //) {
                                //  var f = htmldata.filter(e => e.label == i);
                                //  if (f.length != 0) {
                                //    this.headers.push({
                                //      columnname: i,
                                //      columntype: f[0].type,
                                //      searchname: ''
                                //    });
                                //  }
                                //  else {
                                //    this.headers.push({
                                //      columnname: i,
                                //      columntype: 'text',
                                //      searchname: ''
                                //    });
                                //  }
                                //}
                                //else {
                                //  this.headers.push({
                                //    columnname: i,
                                //    columntype: 'text',
                                //    searchname: ''
                                //  });
                                //}
                                var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip")) 
                                if ((f.length != 0) && (this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
                                  if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                                    && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                                    && (i.toString() != "groupname")
                                    && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") 
                                    && (i.toString() != "active") && (i.toString() != "eutitletooltip")
                                   // && (i.toString() != "eutitletooltip")
                                  ) {
                                    this.headers.push({
                                      columnname: i,
                                      columntype: f[0].type,
                                      searchname: ''
                                    });
                                  }
                                  else {
                                    this.headers.push({
                                      columnname: i,
                                      columntype: 'text',
                                      searchname: ''
                                    });
                                  }
                                }
                                else {
                                  if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview') {
                                    if (i.toString() == 'Created Date') {
                                      this.headers.push({
                                        columnname: i,
                                        columntype: 'date',
                                        searchname: ''
                                      });
                                    }
                                    else if (i.toString() == 'File Name') {
                                      this.headers.push({
                                        columnname: i,
                                        columntype: 'file',
                                        searchname: ''
                                      });
                                    }
                                    else {
                                      this.headers.push({
                                        columnname: i,
                                        columntype: 'text',
                                        searchname: ''
                                      });
                                    }
                                  }
                                }
                              });
                              if (this.by != 'teamallocation' && this.by != 'teamallocationreview' && this.by != 'teamallocationnotreview') {
                                var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                                if (decissiondateindex !== -1) {
                                  var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                                  this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                                  decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                                  this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                                }
                              }
                              this._colspan = this.headers.length
                              this.rowsData = _sortedList;
                              this.groupSearch = false;
                              this.groupExpansionDefault = false;
                              this.SpinnerService.hide();
                            }
                          }
                          else {
                            this.SpinnerService.hide();
                          }
                        }, error => { this.SpinnerService.hide(); });
                      }
                    }
                  });
              }
              else {
                this.previewFilter(this.p);
              }
            }
            else {
              this.showAdvancedSearch(this.advancedSearchId, this.p, this.sortingcondition);
            }
          }
          else {
            this.columnsearchchanged();
          }
        }
      }
      this.pageevent = false;
    }



  }


  async columnsearchchanged() {
    
    var conditionname = '';
    var conditionvalue = '';
    var count = 0;
    this.markallcheckbox = false;
    var fieldsList = [];
    var fieldsname = ''; var tablename = '';

    if (this.formConfigList != undefined && this.formConfigList != null && this.formConfigList.length != 0) {
      this.columnsearch = true;
      //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
      //let html = formConfigField.filter(x => x.displaystatus == 1);
      //html.forEach(element => {
      //  element['label'] = element.name;
      //});
      if (this.by == "teamallocation" || this.by == "teamallocationreview" || this.by == "teamallocationnotreview") {
        count = 0;
        for (var col of this.headers) {
          
         // 'to_char(lower(l.' + col + '):: timestamp, "mm/dd/yyyy")'
          conditionvalue = $("#columnsearch_" + count).val();
          this.headers['searchname'] = conditionvalue;
          conditionvalue = conditionvalue.replace('\'', '\'\'').trim();
          if (conditionvalue != '' && conditionvalue != undefined) {
            if (col.columnname.trim() != 'Created Date') {
              fieldsList.push({
                tablename: "",
                fieldsname: col.columnname.trim(),
                condition: 'contains',
                fieldstype: "",
                label: col.columnname.trim(),
                value: conditionvalue
              });
            }
            else {
              fieldsList.push({
                tablename: "",
                fieldsname: col.columnname.trim(),
                condition: 'between',
                fieldstype: "date",
                label: col.columnname.trim(),
                value: conditionvalue
              });
            }
          }
          count = count + 1;
        }
      }
      else {
        var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
        let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;
        if (htmldata != undefined && htmldata != null && htmldata.length != 0) {
          htmldata.forEach(i => {
            if (i.type != 'hidden' && i.type != 'header' && i.type != 'paragraph') {
              count = 0;
              for (var col of this.headers) {
                if (i.label == col.columnname) {
                  conditionvalue = $("#columnsearch_" + count).val();
                  this.headers['searchname'] = conditionvalue;
                  conditionvalue = conditionvalue.replace('\'', '\'\'').trim();
                  if (conditionvalue != '' && conditionvalue != undefined) {
                    fieldsname = i.name.trim();
                    if (i.tablename != undefined && i.tablename != null) {
                      tablename = i.tablename.trim();
                    }

                    else {
                      tablename = '';
                    }
                    if (i.type != 'date') {
                      fieldsList.push({
                        tablename: tablename,
                        fieldsname: i.formcontrolname.trim(),
                        condition: 'contains',
                        fieldstype: i.type.trim(),
                        label: i.label.trim(),
                        value: conditionvalue
                      });
                    }
                    else {
                      fieldsList.push({
                        tablename: tablename,
                        fieldsname: i.formcontrolname.trim(),
                        condition: 'between',
                        fieldstype: i.type.trim(),
                        label: i.label.trim(),
                        value: conditionvalue
                      });
                    }

                    break;
                  }
                }
                count = count + 1;
              }
            }
          });
        }

        //this._columnsearchgroup = [];
        //this._columnsearchgroup.push({
        //  fieldsname: '',
        //  fieldscondition: fieldsList,
        //  formconfigid: this.selectedFormConfigId
        //});
      }

      this._columnsearchgroup = [];
      if (this.previewfilterflag == false && this.by != "teamallocation" && this.by != "teamallocationreview" && this.by != "teamallocationnotreview") {
        this._columnsearchgroup.push({
          fieldsname: '',
          fieldscondition: fieldsList,
          formconfigid: this.selectedFormConfigId
        });
      }
      else if (this.by == "teamallocation") {
        this._columnsearchgroup.push({
          fieldsname: 'teamallocation',
          fieldscondition: fieldsList,
          formconfigid: this.selectedFormConfigId
        });
      }
      else if (this.by == "teamallocationreview") {
        this._columnsearchgroup.push({
          fieldsname: 'teamallocationreview',
          fieldscondition: fieldsList,
          formconfigid: this.selectedFormConfigId
        });
      }
      else if (this.by == "teamallocationnotreview") {
        this._columnsearchgroup.push({
          fieldsname: 'teamallocationnotreview',
          fieldscondition: fieldsList,
          formconfigid: this.selectedFormConfigId
        });
      }
      else {
        fieldsname = this.selectedFormFields.map(e => { return e.formfieldsid });
        this._columnsearchgroup.push({
          fieldsname: fieldsname,
          fieldscondition: fieldsList,
          formconfigid: this.selectedFormConfigId
        });
      }
      this.loadcolumnsearchdata(this._columnsearchgroup, 1);
    }
  }

  columnsearchshowhide() {
    if (this.columnshow == true)
      this.columnshow = false;
    else
      this.columnshow = true;
  }

  //columnsearchcancel() {
  //  this.columnshow = false;
  //  this.Loadformdetails(1);

  //}
  columnsearchcancel() {
    this.columnshow = false;
    //this.Loadformdetails(1);
    if (this.advancedSearchId == 0) {
      if (this.previewfilterflag == false)
        this.Loadformdetails(1);
      else
        this.previewFilter(1);
    }
    else
      this.showAdvancedSearch(this.advancedSearchId, 1, this.sortingcondition);
  }

  loadcolumnsearchdata(_columnsearchgroup, pagenumber) {
    
    this.filterValue = [];
    this.SpinnerService.show();
    this.filterPatchData = _columnsearchgroup;
    var advancedSearchIdNumber = 0;
    if (this.advancedSearchId == 0)
      advancedSearchIdNumber = 0;
    else
      advancedSearchIdNumber = this.advancedSearchId;
    let formdata: any = [];
    formdata.push({
      advancedSearchId: advancedSearchIdNumber,
      pageno: this.p,
      itemsperpage: this.itemsPerPageText,
      userid: this.userid,
      fieldscondition: JSON.stringify(_columnsearchgroup[0]),
      archiveyear: this.archiveyear
    });
    this.countConditionObj = formdata[0];
    
    this.formdashboardservice.getformadvancedsearchdetailscount(formdata[0]).subscribe(res => {
      if (res != undefined && res != null) {
        this.totalformdetailcount = JSON.parse(res.body[0].formdetails)[0].count;
      }
      let data: any = [];
      if (this.sortingcondition == '') {
        data.push({
          advancedSearchId: advancedSearchIdNumber,
          pageno: this.p,
          userid: this.userid,
          itemsperpage: this.itemsPerPageText,
          fieldscondition: JSON.stringify(_columnsearchgroup[0]),
          archiveyear: this.archiveyear
        });
      }
      else {
        data.push({
          advancedSearchId: advancedSearchIdNumber,
          pageno: this.p,
          userid: this.userid,
          itemsperpage: this.itemsPerPageText,
          fieldscondition: JSON.stringify(_columnsearchgroup[0]),
          sorting: this.sortingcondition,
          archiveyear: this.archiveyear
        });
      }
      this.getvaluesConditionObj = data[0];
      this.isadvancesearch = true;

      this.formdashboardservice.getformadvancedsearchdetails(data[0]).subscribe(async res => {
        if (res != undefined && res.length != 0 && res.body[0].formdetails != null) {
          let _searchDocumentList: any = [];
          _searchDocumentList = JSON.parse(res.body[0].formdetails);
          this.selectedFormConfigId = _searchDocumentList[0].formconfigid;
          // this.formConfigName = _searchDocumentList[0]['Form Name'];
          this.formConfigName = this.selectedNodeText;
          if ((_searchDocumentList != undefined) && (_searchDocumentList.length != 0)) {
            //let formConfigField = await this.getFormDisplayField(this.selectedFormConfigId);
            //let html = formConfigField.filter(x => x.displaystatus == 1);
            //html.forEach(element => {
            //  element['label'] = element.name;
            //});
            var htmlvalue = JSON.parse(this.formConfigList.filter(e => e.dbid == this.databaseId && e.active == 1 && e.formconfigid == this.selectedFormConfigId)[0].htmldata);
            let htmldata = htmlvalue;//html.length > 0 ? html : htmlvalue;
            var _headers = Object.keys(_searchDocumentList[0]);
            var searchList = this.headers;
            this.headers = [];
            _headers.forEach(i => {
              //          if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
              //            && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
              //            && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
              //          ) {
              //            var f = htmldata.filter(e => e.label == i);
              //            if (f.length != 0) {
              //              this.headers.push({
              //                columnname: i,
              //                columntype: f[0].type,
              //                searchname: ''
              //              });
              //            }
              //else {
              //            this.headers.push({
              //              columnname: i,
              //              columntype: 'text',
              //              searchname: ''
              //            });
              //          }
              //          }
              //          else {
              //            this.headers.push({
              //              columnname: i,
              //              columntype: 'text',
              //              searchname: ''
              //            });
              //          }
              var f = htmldata.filter(e => e.label == i && (i.toString() != "eutitletooltip"));
              if (f.length != 0) {
                if ((i.toString() != 'documentid') && (i.toString() != "Created By") && (i.toString() != "Created On")
                  && (i.toString() != 'read') && (i.toString() != 'Form Name') && (i.toString() != 'formconfigid')
                  && (i.toString() != "groupname")
                  && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active") &&
                  (i.toString() != "eutitletooltip")
                ) {
                  this.headers.push({
                    columnname: i,
                    columntype: f[0].type,
                    searchname: ''
                  });
                }
                else {
                  this.headers.push({
                    columnname: i,
                    columntype: 'text',
                    searchname: ''
                  });
                }
              }
              else {
                if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview') {
                  if (i.toString() == 'Created Date') {
                    this.headers.push({
                      columnname: i,
                      columntype: 'date',
                      searchname: ''
                    });
                  } else {
                    this.headers.push({
                      columnname: i,
                      columntype: 'text',
                      searchname: ''
                    });
                  }
                }
              }
            });

            if (this.headers.length != 0) {
              this.headers.forEach((i, ind) => {
                if ((i.columnname.toString() != 'documentid') && (i.columnname.toString() != "Created By")
                  && (i.columnname.toString() != "Created On") && (i.columnname.toString() != 'read')
                  && (i.columnname.toString() != 'Form Name') && (i.columnname.toString() != 'formconfigid')
                  && (i.toString() != "modifiedby") && (i.toString() != "modifiedon") && (i.toString() != "active")
                  && (i.columnname.toString() != "requestdetails") && (i.columnname.toString() != "vieweduserdetails")
                ) {
                  if (searchList.filter(e => e.columnname != undefined && e.columnname == i.columnname).length != 0) {
                    if (searchList.filter(e => e.columnname == i.columnname)[0].searchname != '') {
                      var a = searchList.filter(e => e.columnname == i.columnname)[0].searchname;
                      if (a != null) {
                        if (a.length != 0) {
                          //this.headers[ind]['searchname'] = a;
                          if(searchList.filter(e => e.columntype == i.columntype).length>0){
                          if (searchList.filter(e => e.columntype == i.columntype)[0].columntype != 'date') 
                          {
                            this.headers[ind]['searchname'] = a;
                          }
                          else {
                            var datearray = [];
                            datearray = a;
                            if (datearray.length == 2) {
                              let datestring: string = "";
                              datestring = this.datePipe.transform(datearray[0], "MM/dd/yyyy") + ' - ' + this.datePipe.transform(datearray[1], "MM/dd/yyyy");
                              this.headers[ind]['searchname'] = datestring;
                            }
                            else {
                              this.headers[ind]['searchname'] = a;
                            }
                          }
                         
                        } else
                        {
                          if (this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview') {
                            this.headers[ind]['searchname'] = a;
                            }
                        }



                        }
                        
                        //if (a.length != 0) {
                        //  if (searchList.filter(e => e.columntype == i.columntype)[0].columntype == 'date') {
                        //    this.headers[ind]['searchname'] = this.datePipe.transform(a[0].split[0], "MM/dd/yyyy") + '-' + this.datePipe.transform(a[1].split[1], "MM/dd/yyyy");
                        //    //this.headers[ind]['searchname'] = this.datePipe.transform(a[0].split[0], "MM/dd/yyyy") + this.datePipe.transform(a[1].split[1], "MM/dd/yyyy");

                        //  }
                        //  else {
                        //    this.headers[ind]['searchname'] = a;
                        //  }
                        //}
                      }
                    }
                  }
                }

              });
              if (this.by != 'teamallocation' && this.by != 'teamallocationreview' && this.by != 'teamallocationnotreview') {
                                    var decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                    if (decissiondateindex !== -1) {
                      var allocationobj = this.headers.find(e => e.columnname === 'Allocation');
                      this.headers = this.headers.filter(e => e.columnname != 'Allocation');
                      decissiondateindex = this.headers.findIndex(x => x.columnname === "Decision Date");
                      this.headers.splice(decissiondateindex + 1, 0, allocationobj);
                      }
              }
            }

            this.rowsData = [];
            //after data get cleaned up check the user read document status
            if (_searchDocumentList.length != 0) {
              this.rowsData = _searchDocumentList;
              this.groupSearch = false;
              this.SpinnerService.hide();
            }
          }
        }
        else {
          // this.toastr.error('No preview data found');
          this.rowsData = [];
          this.groupSearch = false;
          this.SpinnerService.hide();
        }


      },
        err => {
          this.toastr.error('Not able to get preview data');
          this.SpinnerService.hide();
          this.rowsData = [];
        });
    });


  }

  async advancedSearchValuesLoad(data) {
    
    this.columnsearch = false;
    var tmpList = [];
    this.formFieldsListTmp = [];
    this.formFieldsList = [];
    this.selectedFormId = data[0].formconfigid;
    //selected fields list
    //let formConfigField = await this.getFormDisplayField(this.selectedFormId);
    //let html = formConfigField.filter(x => x.displaystatus == 1);
    //html.forEach(element => {
    //  element['label'] = element.name;
    //});
    var htmlvalue = JSON.parse(this.list.filter(e => e.formconfigid == this.selectedFormId)[0].htmldata);
    let htmldata = htmlvalue;// html.length > 0 ? html : htmlvalue;

    if (htmldata != undefined && htmldata != null && htmldata.length != 0) {
      htmldata.forEach((i, ind) => {
        if (i.type != 'hidden' && i.type != 'header' && i.type != 'paragraph') {
          this.formFieldsListTmp.push({ formfieldsid: ind + 1, formfields: i.label });
          tmpList.push({ formfieldsid: ind + 1, formfields: i.formcontrolname.toLowerCase(), formname: i.label });
        }
      });
      this.formFieldsListTmp = this.formFieldsListTmp.sort((a, b) => a.formfields.localeCompare(b.formfields));
      this._dropdownSettingsform = {
        singleSelection: false,
        idField: 'formfieldsid',
        textField: 'formfields',
        selectAllText: 'Select All',
        unSelectAllText: 'UnSelect All',
        itemsShowLimit: 7,
        allowSearchFilter: true
      };
      this.formFieldsList = JSON.parse(JSON.stringify(this.formFieldsListTmp));
    }



    var selectedFormFieldstmp = [];
    if (data[0].fieldsname != undefined && data[0].fieldsname != null) {
      var s = JSON.parse(data[0].fieldsname).fieldsname;
      if (s.length != 0) {
        // s.forEach(i => {
        for (var i = 0; i < s.length; i++) {
          var a = tmpList.filter(e => e.formfields == s[i]);
          if (a.length != 0) {
            selectedFormFieldstmp.push({ formfieldsid: a[0].formfieldsid, formfields: a[0].formname });
          }
        }
        this.selectedFormFields = selectedFormFieldstmp.sort((a, b) => a.formfields.localeCompare(b.formfields));
      }
    }



    //fields condition
    if (data[0].fieldscondition != undefined && data[0].fieldscondition != null) {
      var _fieldsconditions = JSON.parse(data[0].fieldscondition).FieldsCondition;
      if (_fieldsconditions.length != 0) {
        _fieldsconditions.forEach((i, index) => {
          //var a = tmpList.filter(e => e.formfields == i.fieldsname);
          //if (a.length != 0) {
          var formfield = this.selectedFormFields.filter(e => e.formfields == i.label);
          i.fieldsname = formfield[0].formfieldsid;
          // _fieldsconditions[index]["formfieldsid"] = a[0].formfieldsid;
          //  this.selectedfieldname[index] = a[0].formname;
          //}
          _fieldsconditions[index]["fieldeditmode"] = true;
          // if (i.fieldstype != 'date') {
          //   if (i.condition == 'Equals')
          //     i.condition = 1;
          //   else
          //     i.condition = 2;
          // }
          if (i.fieldstype == 'date') {
            // if (i.condition == 'Equals')
            //   i.condition = 1;
            // else
            //   i.condition = 2;
            this.selectedfieldDate[index] = [i.value.split('-')[0] + "T18:51:51.000Z", i.value.split('-')[1] + "T18:51:51.000Z"] as any;
          }
        });
        this.fieldgroupListadded = _fieldsconditions;
      }
    }




    //author dropdown loading
    if (data[0].author != undefined && data[0].author != null) {
      var _author = JSON.parse(data[0].author).author;
      if (_author.length != 0) {
        for (var i = 0; i < _author.length; i++) {
          var d = this.authorListTmp.filter(e => e.authorId == _author[i])
          if (d.length != 0) {
            this._selectedItems.push({ authorId: d[0].authorId, authorName: d[0].authorName });
          }
        }
      }
    }
    //date to filter
    if (data[0].daterange != undefined && data[0].daterange != null) {
      var _date = data[0].daterange;
      this.selectedStartDate = [_date.split(',')[0] + "T18:51:51.000Z", _date.split(',')[1] + "T18:51:51.000Z"];
    }
    //search name
    this.filternameTxt = data[0].advancedsearch;

    //show all filters
    if (data[0].showforall == 1) {
      this.showAllChecked = true;
    }
  }

  keypress(eve) {
    if (eve.keyCode == 13) {
      this.columnsearchchanged();
    }
  }

  destinationChange(event, source, target) {
    console.log(event);
    if (this.fieldgroupListadded.length > 0) {
      let valid = [];
      this.fieldgroupListadded.forEach(element => {
        let index = event.findIndex(x => x.formfieldsid == element.formfieldsid);
        if (index == -1) {
          this.selectedFormFields.push(source.filter(s => s.formfieldsid == element.formfieldsid)[0]);
          valid.push('invalid');
        }
      });
      if (valid.length > 0) {
        this.toastr.warning('Cannot move the field');
      }
    }
  }

  keypresspage(eve) {
    var charCode = (eve.which) ? eve.which : eve.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57))
      return false;
    if (eve.keyCode == 13) {
      this.getPage(eve.target.value);
    }
  }

  fileDownload(item, filename) {
    this.SpinnerService.show();
    if (item != undefined && item != null) {
      let fileData: any = [];
      fileData.push({
        'documentId': item["documentid"], 'dbName': this.databaseName, 'formConfigId': this.selectedFormConfigId, 'fileName': filename
      });
      this.requestConfigService.DownloadFormFile(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, filename);
        this.SpinnerService.hide();
      },
        error => {

          if (error.error == 'user loggedin')
            this.toastr.info('User Still loggined and working on the same file')
          else
            this.toastr.error('File not found');

          this.SpinnerService.hide();
        });
    }
  }


  splitFilename(fileNames: string) {
    //console.log(fileNames.split(/?<=\.[a - z] ]/));
    return fileNames.split(/(?<=\.[a-z]+);/g)
    //return fileNames.split(';');
  }

  DownloadFormFileAsZip(item) {

    console.log(item);
    this.SpinnerService.show();
    if (item != undefined && item != null) {
      var documentid = 0;
      if ((this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
        documentid = item["documentid"];
      }
      else {
        documentid = item["ACRN Doc ID"];
      }
      var fileName = this.formConfigName + '_' + documentid;
      let fileData: any = [];
      fileData.push({
        'documentId': documentid, 'dbName': this.databaseName, 'formConfigId': this.selectedFormConfigId, 'fileName': fileName
      });

      this.requestConfigService.DownloadFormFileAsZip(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName + '.zip');
        this.SpinnerService.hide();
      },
        error => {
          if (error.error == 'user loggedin')
            this.toastr.info('User Still loggined and working on the same file')
          else
            this.toastr.error('File not found');

          this.SpinnerService.hide();
        });
    }
  }
  download(obj) {
    this.headers.forEach(element => {
      if (element.columntype == 'file' && obj[element.columnname] != null) {
        let a = this.splitFilename(obj[element.columnname]);
        ///Newly Added
        if (this.databaseName == 'Non Case Law') {
          this.DownloadNonCaseLawFormFile(obj, a[0]);
        } else {
          ////
          if (a.length > 1) {
            this.DownloadFormFileAsZip(obj);
          } else {
            this.fileDownload(obj, a[0]);
          }
          ////newly added  
        }
        ///
      }
    });
  }
  async getpagepreference() {
    let model = {
      userid: this.userid,
      pagename: 'formdashboard'
    };
    await this.formdashboardservice.getpagepreferencedetails(model).toPromise().then(res => {
      console.log('res: ', res);
      if (res != null) {
        let data = JSON.parse(res[0].j);
        this._itemsPerPage = data[0].itemsperpage == undefined || data[0].itemsperpage == null ? this._itemsPerPage : data[0].itemsperpage;
        this.itemsPerPageText = this._itemsPerPage;
      }

    });
  }



  addpagepreference(value) {
    let model = {
      userid: this.userid,
      pagename: 'formdashboard',
      itemsperpage: value
    };

    this.formdashboardservice.addpagepreferencedetails(model).toPromise().then(res => {
      console.log('res: ', res);

    });
  }

  toggle1(groupname, id, selectedNode) {
   
    if (selectedNode == 'By Allocation and Court') {
      if ($('#iconup' + id).hasClass('glyphicon-chevron-up') == true) {
        $('#iconup' + id).removeClass('glyphicon-chevron-up').addClass('glyphicon-chevron-down');
        this.groupleveldata = groupname;
        this.groupleveldataname = groupname;
        this.Loadformdetails(1);
        //this.innerRowsData = this.rowsData;
        this.groupname2 = groupname;
        $('.groupbyinnertable_' + id).show();
      }
      else {
        $('.groupbyinnertable_' + id).hide();
        this.groupleveldata = '';
        this.innerRowsData = [];
        $('#iconup' + id).removeClass('glyphicon-chevron-down').addClass('glyphicon-chevron-up');
      }
    }
    else {
      this.groupleveldata = '';
      this.toggle(groupname, id);
    }

    }
    opennewtab(event){
      let database = this.databaseId + '*' + this.databaseName;
       
       let queryParams = {};
       queryParams['db'] =this.enc.encryptUsingAES256(this.databaseId.toString());// this.databaseId;
       queryParams['formDB'] =this.enc.encryptUsingAES256(database.toString()); //database;
       this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview' ?   queryParams['data'] = this.enc.encryptUsingAES256(event.item["ACRN Doc ID"] .toString()) : queryParams['data'] = this.enc.encryptUsingAES256(event.item["documentid"] .toString());
        queryParams['formConfigId'] = this.enc.encryptUsingAES256(this.selectedFormConfigId.toString());//this.selectedFormConfigId;
       queryParams['mode'] =  this.enc.encryptUsingAES256('newtab');//'View';
       event.item["read"]=true;   
       const navigationExtras: NavigationExtras = {
         queryParams,   
        /* state: {
           db: this.databaseId,
           formDB: database,
           data: this.by == 'teamallocation' || this.by == 'teamallocationreview' || this.by == 'teamallocationnotreview' ? event.item["ACRN Doc ID"] : event.item["documentid"],
           formConfigId: this.selectedFormConfigId,
           mode: 'View',
           page: this.p,
           selectedgroup: this.by,
           searchdata: this.searchData,
           filterTable: this.filterPatchData.length > 0,
           filterValue: this.filterPatchData.length > 0 ? JSON.stringify(this.filterPatchData) : '',
           isCustomSearch: this.isCustomSearch,
           itemsPerPage: this._itemsPerPage,
           customSearchData: this.isCustomSearch ? this.customSearchData : '',
           selectedNodeText: this.selectedNodeText,
           subPage: this.subPage,
           team:this.by,
           columnsearchname: JSON.stringify(this.headers),
           columnsearchgroup: JSON.stringify(this._columnsearchgroup),
           isSort: this.isSort,
           sortingconditionValue: this.colkey,
           sortDirectionValue: this.sortDirection,
           customSearchSortConditionValue: this.sortingcondition,
           selectedNodeValue: this.selectedNodeValue,
           archiveyear: this.archiveyear,
           groupleveldata: this.groupleveldata,
           countConditionObj: JSON.stringify(this.countConditionObj),
           getvaluesConditionObj: JSON.stringify(this.getvaluesConditionObj),
           isadvancesearch: this.isadvancesearch
   
         }*/
       };
      let url = this._router.createUrlTree(['/home/formrender'], navigationExtras);
      window.open('#' + url.toString(), '_blank');
     // localStorage.setItem("documentid_k",  queryParams['data']);
     // localStorage.setItem("navigationExtras_k", JSON.stringify(navigationExtras));
      // this._router.navigate(['/home/formrender'], navigationExtras);
   
    }

  markassread(event) {
    
    if (!event.item['read']) {
      this.SpinnerService.show();
      var documentStatus = [];

      documentStatus.push({
        'formconfigid': this.selectedFormConfigId,
        'documentid': +event.item["documentid"],
        'readstatus': 1,
        'createdby': this.userid
      });
      this.formdashboardservice.insertDocumentStatus(documentStatus[0]).subscribe(res => {
        if (res != undefined) {
          if (res.body != 0) {
            this.Loadformdetails(this.p);
            this.toastr.success('Form updated successfull');
            this.SpinnerService.hide();
            // this.columnsearchchanged();
          }
        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while updating the status');
      });
    } else {
      this.SpinnerService.hide();
      this.toastr.warning('This document is already read');
    }
  }


  markassreadall() {
    
    this.SpinnerService.show();
    var documentStatus = [];
    let docids = [];
    this.rowsData.forEach(element => {
      if (element.isReadCheck) {
        docids.push({ id: element.documentid });
      }
    });
    this.markdocasread(docids, '');

  }


  checkAllUnread(event) {
    this.rowsData.forEach(element => {
      if (element.isReadCheck != null) {
        element.isReadCheck = event.currentTarget.checked;
      }
    });
  }

  markdocasread(docids, mode) {
    if (docids.length > 0) {
      let documentStatus = [];
      documentStatus.push({
        'formconfigid': this.selectedFormConfigId,
        'documentid': JSON.stringify(docids),
        'readstatus': 1,
        'createdby': this.userid
      });
      this.formdashboardservice.insertDocumentReadStatus(documentStatus[0]).subscribe(res => {
        if (res != undefined) {
          if (res.body != 0) {
            // this.loadcolumnsearchdata(this._columnsearchgroup, this.p);
            if (mode == 'formgroup') {
              this.entry.forEach(container => {
                let containerid = container.viewContainerRef.element.nativeElement.id;
                if (container.viewContainerRef !== undefined) {
                  if (container.viewContainerRef['_embeddedViews'].length != 0) {
                    for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
                      if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined) {
                        let instance = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance;
                        instance.LoadSearchedFormDetails(instance.p);
                        instance.markallcheckbox = false;
                      }
                    }
                  }
                }
              });
            } else {
              this.Loadformdetails(this.p);
              this.markallcheckbox = false;
              this.SpinnerService.hide();
            }
            // this.LoadSearchedFormDetails(this.p);
            this.toastr.success('Form updated successfull');
            // this.columnsearchchanged();
          }
        }
      }, err => {
        this.SpinnerService.hide();
        this.toastr.error('Error while updating the status');
      });
    } else {
      this.SpinnerService.hide();
      this.toastr.warning('Please select atleast one docment');
    }
  }

  getDocIds() {
    let documentids = [];
    this.entry.forEach(container => {
      let containerid = container.viewContainerRef.element.nativeElement.id;
      if (container.viewContainerRef !== undefined) {
        if (container.viewContainerRef['_embeddedViews'].length != 0) {
          for (let i = 0; i < container.viewContainerRef['_embeddedViews'].length; i++) {
            if (container.viewContainerRef['_embeddedViews'][i] != undefined && container.viewContainerRef['_embeddedViews'][i] != undefined) {
              var prodDetails = container.viewContainerRef['_embeddedViews'][i].nodes[1].instance.getSelectedIds();
              prodDetails.forEach(element => {
                documentids.push(element);
              });
            }
          }
          console.log('documentids: ', documentids);
        }
      }
    });
    this.markdocasread(documentids, 'formgroup');

  }
  checkreadchange(event) {
    let readcheckboxcount = this.rowsData.filter(x => x.isReadCheck != null);
    let readcheckcount = this.rowsData.filter(x => x.isReadCheck == true);
    if (readcheckboxcount.length == readcheckcount.length) {
      this.markallcheckbox = true;
    } else {
      this.markallcheckbox = false;
    }
  }
  DownloadNonCaseLawFormFile(item, fname) {

    console.log(item);
    this.SpinnerService.show();
    if (item != undefined && item != null) {
      var documentid = 0;
      if ((this.by != 'teamallocation') && (this.by != 'teamallocationreview') && (this.by != 'teamallocationnotreview')) {
        documentid = item["documentid"];
      }
      else {
        documentid = item["ACRN Doc ID"];
      }
      var fileName = this.formConfigName + '_' + documentid;
      let fileData: any = [];
      fileData.push({
        'documentId': documentid, 'dbName': this.databaseName, 'formConfigId': this.selectedFormConfigId, 'fileName': fname, 'zipName': fileName
      });

      this.requestConfigService.DownloadNonCaseLawFormFile(fileData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        if (res.body.type == 'zip') {
          saveAs(objectURL, fileName + '.zip');
        }
        if (res.body.type == 'file') {
          saveAs(objectURL, fname);
        }
        this.SpinnerService.hide();
      },
        error => {
          if (error.error == 'user loggedin')
            this.toastr.info('User Still loggined and working on the same file')
          else
            this.toastr.error('File not found');

          this.SpinnerService.hide();
        });
    }
  }

 viewrequest(request) {
    // let a = request.requestid + '*' + request.requesttypeid
    // this.router.navigate(['/home/requestconfig'], { queryParams: { requestid: request.requestid, requesttypeid: request.requesttypeid, redirectmode: 'viewrequest' } })
    let a = request.requestid + '*' + request.requesttypeid;
    let queryParams = {};
    queryParams['requestid'] = this.enc.encryptUsingAES256(request.requestid.toString());
    queryParams['requesttypeid'] = this.enc.encryptUsingAES256(request.requesttypeid.toString());
    queryParams['redirectmode'] = this.enc.encryptUsingAES256('viewrequest');
    // const navigationExtras: NavigationExtras = {
    //   queryParams
    // };
    // this.router.navigate(['/home/requestconfig'], navigationExtras);
    let url = this._router.createUrlTree(['/home/requestconfig'], { queryParams: queryParams });
    window.open('#' + url.toString(), '_blank');
  }


  fileDownloadrequest(request, fileName, type) {
    this.SpinnerService.show();
    // var s = this.databases.filter(e => e.databaseid == request.dbid)
    // if (s != undefined && s != null && s.length != 0) {
    var requesttype = '';
    if (request.requesttypeid == 1)
      requesttype = 'courtagoopinionrequest';
    if (request.requesttypeid == 2)
      requesttype = 'researchgrouprequest';
    if (request.requesttypeid == 3)
      requesttype = 'informationrequest';
    if (request.requesttypeid == 4)
      requesttype = 'internetdownloadrequest';
    if (request.requesttypeid == 5)
      requesttype = 'conversionrequest';

    // add the line starts

    let requestData: any = [];
    requestData.push({
      'requesttype': requesttype, 'dbname': request.dbname, 'requestid': request.requestid, 'fileName': fileName, 'type': type
    });

    request.finalupload = request.finalupload == null ? '' : request.finalupload;
    request.finaluploadsupportingfiles = request.finaluploadsupportingfiles == null ? '' : request.finaluploadsupportingfiles;

    let a = request.finalupload.split(/(?<=\.[a-z]+):/g);
    let b = request.finaluploadsupportingfiles.split(/(?<=\.[a-z]+):/g);

    if (a.length > 1 || b.length > 1) {




      if (type == 'finaloutput')
        requestData[0].fileName = requesttype + '_' + request.requestid;
      else {
        if (b.length > 1)
          requestData[0].fileName = requesttype + 'finalsupporting' + '_' + request.requestid;
      }

      // requestData[0].fileName = requesttype + '_' + request.requestid;

      fileName = requestData[0].fileName;
      this.requestConfigService.DownloadFileRequestWithSpecialCharactersasZIP(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName + '.zip');
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });

    } else {
      this.requestConfigService.DownloadFileRequestWithSpecialCharacters(requestData[0]).subscribe(res => {
        var content = res.body.file;
        let objectURL = 'data:application/octet-stream;base64,' + res.body.file;
        saveAs(objectURL, fileName);
        this.SpinnerService.hide();
      },
        error => {
          this.toastr.error('File not found');
          this.SpinnerService.hide();
        });

    }

    // add the line ends

    // comment the line starts

    // this.requestConfigService.DownloadFileRequest(request.dbname, requesttype, request.requestid, type, request.finalupload).subscribe(res => {
    //  var content = res.file;
    //  let objectURL = 'data:application/octet-stream;base64,' + res.file;
    //  saveAs(objectURL, request.finalupload);
    // });
    // }

    // comment the line ends
  }
	public onContextMenuView($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      contextMenu: this.viewMenu,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }								   
  public onContextMenu($event: KeyboardEvent, item: any): void {
    this.contextMenuService.show.next({
      anchorElement: $event.target,
      // Optional - if unspecified, all context menu components will open
      // contextMenu: this.contextMenu,
      contextMenu: this.basicMenu1,
      event: <any>$event,
      item: item,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }
 
  public searchbyallocationfunction() {
    this.Loadformdetails(1);
  }
showMoreItems(value,$event,item) 
{
  this.item = item;
  //this.paginationLimit = Number(this.paginationLimit) + value;
  this.paginationLimit = 15;
  $event.preventDefault();
  $event.stopPropagation();
   }
  showLessItems(value, $event,item)
   {
     this.item = item;
    this.paginationLimit = value > 5 ? 5 : value;
   //
     $event.preventDefault();
     $event.stopPropagation();

   }










   alterDescriptionText() {
    this.showShortDesciption = !this.showShortDesciption
 }


  showMoreItems1(value, $event, item)
  {
    this.item = item;
  // this.paginationLimit1 = Number(this.paginationLimit1) + value;
    this.paginationLimit1 = 15;
   $event.preventDefault();
   $event.stopPropagation();
 }
  showLessItems1(value, $event, item)
  {
    this.item = item;
   this.paginationLimit1 = value > 5 ? 5 : value;
    
   $event.preventDefault();
   $event.stopPropagation();
 }

 alterDescriptionText1() {
  this.showShortDesciption1 = !this.showShortDesciption1
}

keypress_searchallocation(event){
  if (event.keyCode == 13) {
    this.searchbyallocationfunction();
  }
}
  
}
